import React, { useState, useEffect, useRef, useCallback } from 'react';
import ReviewPopupKYC from './review-popup';
import DocumentPreview from '../Create-Investment/documentpreview';
import ActivityLog from '../../Components/ActivityLog/activity-log';
import StatusButton from '../../Components/Onbaording/status-button';
import SectionStatusGrid from '../../Components/Onbaording/status-section';

import FileUploadDisplay from '../../Components/Onbaording/file-display';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { useToast } from '../../Utils/toastContext';
import { useSelector } from 'react-redux';
import { debounce } from 'lodash';
// import StatusDropdown from "../../Components/Onbaordingp/section-status-dropdown";
import EDDModal from '../../Pages/Risk-Assessment/edd-modal';
import UserQuestionnaire from '../../Pages/Risk-Assessment/user-questionnarie';
import AuditStepper from '../../Components/Onbaording/onboarding-stepper';
import { formatDateTimeUTC } from '../../Constants/helper-functions';
import { screeningHits, auditRejected } from './dummy-data';

import ScreeningPanel from '../../Components/Onbaording/ScreeningPanel';

//   {
//     key: 'submitted',
//     label: 'Application Submitted',
//     icon: 'description',
//     status: 'completed',
//   },
//   // {
//   //   key: 'sanction',
//   //   label: 'Sanction Verified',
//   //   icon: 'gavel',
//   //   status: 'completed',
//   // },
//   {
//     key: 'identity',
//     label: 'Identity Verified',
//     icon: 'verified_user',
//     status: 'completed',
//   },
//   {
//     key: 'manual',
//     label: 'Manual Review',
//     icon: 'manage_search',
//     status: 'active',
//   },
//   {
//     key: 'approved',
//     label: 'Approved',
//     icon: 'check_circle',
//     status: 'pending',
//   },
// ];
/* ------------------------------------------------------------------
   Joint account member status helpers. The API returns each member's
   status as joint_account.members[].status = { id, label } (e.g.
   "to_review", "sent_for_resubmit").
   ------------------------------------------------------------------ */
const formatMemberStatusLabel = (label) =>
  String(label || '')
    .replace(/_/g, ' ')
    .replace(/\b\w/g, (letter) => letter.toUpperCase());

const getMemberStatusChipClass = (label) => {
  const key = String(label || '').toLowerCase();
  if (key === 'approved' || key === 'completed') {
    return 'bg-emerald-50 text-emerald-700 border-emerald-200';
  }
  if (key === 'rejected') {
    return 'bg-rose-50 text-rose-700 border-rose-200';
  }
  if (key === 'to_review' || key === 'in_review') {
    return 'bg-amber-50 text-amber-700 border-amber-200';
  }
  if (key === 'sent_for_resubmit') {
    return 'bg-indigo-50 text-indigo-700 border-indigo-200';
  }
  return 'bg-slate-100 text-slate-600 border-slate-200';
};

/* The "View Review Application" action is only offered once the member
   has actually submitted their application — i.e. their status is NOT
   onboarding/pending. */
const canViewReviewApplication = (member) => {
  const label = String(member?.memberStatus || '').toLowerCase();
  return Boolean(label) && label !== 'onboarding' && label !== 'pending';
};

const ReviewKYC = () => {
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const dropdownRef = useRef();
  const { customerId } = useParams();
  const navigate = useNavigate();
  const updateFieldStatus = useSelector(
    (state) => state.form.updateFieldStatus,
  );
  const roleName = useSelector((state) => state.user.roleName);
  const [showModal, setShowModal] = useState(false);
  const [eddResponse, setEddResponse] = useState(null);
  const [hasCertificate, setHasCertificate] = useState(null);
  const [steps, setSteps] = useState([]);
  const [userStatus, setUserStatus] = useState(null);
  const [screening, setScreening] = useState([]);

  const [sanctionResults, setSanctionResults] = useState(null);
  const [livenessConfirmed, setLivenessConfirmed] = useState(false);
  const location = useLocation();
  const { showToast } = useToast();
  const [issuedCountry, setIssuedCountry] = useState(null);
  const [issuedCountrySecond, setIssuedCountrySecond] = useState(null);

  const [issuedStateSecond, setIssuedStateSecond] = useState(null);
  const [issuedState, setIssuedState] = useState(null);

  const [showPopup, setShowPopup] = useState(false);
  const [taxResidentCountry, setTaxResidentCountry] = useState(null);
  const [nonResCountryText, setNonResCountryText] = useState(null);
  const [photoIdSecondText, setphotoIdSecondText] = useState(null);
  const [photoIdSecond, setphotoIdSecond] = useState(null);
  const [isActivityLogOpen, setIsActivityLogOpen] = useState(false);
  const [fileNonPhotographicId, setfileNonPhotographicId] = useState(null);
  const [fullName, setFullName] = useState(null);
  /* FIX (sole signatory): the signatory can be an existing joint account
     MEMBER (is_sole_signatory) or someone still on the INVITATION list
     (proposed_is_sole_signatory), and there can be more than one. The old
     single-string state only looked at members and silently fell back to
     'Myself', so an invited signatory was never shown. Now we keep a list
     of { name, email, source, isPending } built from both collections. */
  const [signatories, setSignatories] = useState([]);
  const [verificationStatus, setVerificationStatus] = useState('');
  const [dvsTime, setDvsTime] = useState('');
  const [dvsMeessage, setDvsMeessage] = useState('');

  const [nonphotoIdText, setNonPhotoIdText] = useState('');
  const [businessRegistrationNumber, setBusinessRegistrationNumber] =
    useState(null);
  const [fileDriverLinsenceFrontSecond, setFileDriverLinsenceFrontSecond] =
    useState(null);
  const [filePhotographicIdSecond, setfilePhotographicIdSecond] =
    useState(null);
  const [expiryDate, setExpiryDate] = useState(null);
  const [expiryDateSecond, setExpiryDateSecond] = useState(null);
  const [fileDriverLinsenceBackFirst, setFileDriverLinsenceBackFirst] =
    useState(null);
  const [fileDriverLinsenceBackSecond, setFileDriverLinsenceBackSecond] =
    useState(null);
  const [fileDriverLinsenceFrontFirst, setFileDriverLinsenceFrontFirst] =
    useState(null);
  const [fileDriverLinsenceFront, setFileDriverLinsenceFront] = useState(null);
  const [fileDriverLinsenceBack, setFileDriverLinsenceBack] = useState(null);
  const [isDataAvailable, setIsDataAvailable] = useState(false);
  const [jointAccountID, setJointAccountID] = useState(null);
  const [accountPurpose, setAccountPurpose] = useState(null);
  const [documentNumber, setDocumentNumber] = useState(null);
  const [cardNumber, setCardNumber] = useState(null);
  const [cardNumberSecond, setCardNumberSecond] = useState(null);

  const [applicantCountry, setApplicantCountry] = useState(null);
  const [socialSecurityNumber, setSocialSecurityNumber] = useState(null);
  const [abn, setAbn] = useState(null);
  const [businessName, setBusinessName] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [accountType, setAccountType] = useState({
    verification_id: null,
    value: '',
    status: 'pending',
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const [currentDocument, setcurrentDocument] = useState({});
  const [currentField, setCurrentField] = useState({});
  const [currentFieldName, setCurrentFieldName] = useState('');
  const [currentFieldValue, setCurrentFieldValue] = useState('');
  const [currentFieldType, setCurrentFieldType] = useState('');
  const [nameFromBirth, setNameFromBirth] = useState('');
  const [loadingUpdate, setLoadingUpdate] = useState(false);
  const [taxId, setTaxId] = useState(null);
  const [ownership, setOwnership] = useState(null);
  const [image, setImage] = useState(null);
  const [fullscreen, setFullscreen] = useState(false);
  const [photoId, setphotoId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [firstName, setFirstName] = useState(null);
  const [lastName, setLastName] = useState(null);
  const [middleName, setMiddleName] = useState(null);
  const [profilePic, setProfilePic] = useState(null);
  const [filePhotographicId, setFilePhotographicId] = useState(null);
  const [fileAttorney, setFileAttorney] = useState(null);
  const [filePurpose, setFilePurpose] = useState(null);
  const [thirdPartySign, setThirdPartySign] = useState(null);
  const [photoIdText, setPhotoIdText] = useState(null);
  const [isOpenAction, setIsOpenAction] = useState(false);
  const [businessActivity, setBusinessActivity] = useState(null);
  const [jointAccountMembers, setJointAccountMembers] = useState([]);
  const [meetingData, setMeetingData] = useState([]);
  const [jointAccountActualMembers, setJointAccountActualMembers] = useState(
    [],
  );
  const [signatory, setSignatory] = useState('yes');
  const [businessAddress, setBusinessAddress] = useState(null);
  const [transactionNature, setTransactionNature] = useState(null);

  const [photoIdFirstText, setphotoIdFirstText] = useState('');
  const [photoIdFirst, setphotoIdFirst] = useState(null);
  const [filePhotographicIdFirst, setfilePhotographicIdFirst] = useState(null);
  const [dob, setDob] = useState(null);
  const [formattedDOB, setFormattedDOB] = useState('');
  const [formerNames, setFormerNames] = useState(null);
  const [redAddress, setRedAddress] = useState(null);
  const [clientNo, setClientNo] = useState(null);
  const [fundSource, setFundSource] = useState(null);
  const [description, setDescription] = useState(null);
  const [fileProof, setFileProof] = useState(null);
  const [documentNumberSecond, setDocumentNumberSecond] = useState(null);
  const [mobileNumber, setMobileNumber] = useState('');
  const [customerType, setCustomerType] = useState('');
  const [lastNameSignup, setLastNameSignup] = useState('');
  const [firstNameSignup, setFirstNameSignup] = useState('');
  const [customerStatus, setCustomerStatus] = useState(null);
  const [email, setEmail] = useState('');
  const [statusData, setStatusData] = useState([]);
  const [additionalDocuments, setAdditionalDocuments] = useState([]);
  const [additionalPhotographicDocuments, setAdditionalPhotographicDocuments] =
    useState([]);
  const [onboardingSections, setOnboardingSections] = useState([]);
  /* Which section (if any) is currently being approved via its
     "Approve this section" button */
  const [approvingSection, setApprovingSection] = useState(null);

  const mapQuestions = (questions = []) => {
    const typeMap = {
      text: 1,
      radio: 2,
      select: 3,
      checkbox: 5,
      checkbox_with_percent: 4,
      multi_select: 6,
      file: 8,
    };

    return questions.map((q) => ({
      id: q.id,
      question: q.question_text,
      required: q.required,
      type: {
        value: typeMap[q.type.value] || 1,
      },
      options: (q.options || []).map((opt) => ({
        id: opt.id,
        label: opt.value,
        value: opt.value,
      })),
      answer: q.answer,
    }));
  };
  const pendingQuestions = mapQuestions(
    (eddResponse?.pending || []).flatMap((item) => item.questions || []),
  );

  const completedQuestions = mapQuestions(
    (eddResponse?.completed || []).flatMap((item) => item.questions || []),
  );
  const completedGroups = (eddResponse?.completed || []).map((item) => ({
    id: item.id,
    requestedBy: item.requested_by?.name,
    respondedAt: item.responded_at,
    questions: mapQuestions(item.questions || []),
  }));
  const latest = sanctionResults?.latest;

  const fullNameSanction = latest?.request_payload?.full_name || '-';
  const screeningDate = latest?.response_timestamp || '-';

  const uiMessage = latest?.ui?.message;
  const uiSummary = latest?.ui?.summary;
  const sourcesChecked =
    latest?.response_payload?.data?.evidence?.sources_checked || [];

  const matchedSources = latest?.matched_sources || [];
  const decision = latest?.decision || {};
  const getSourceStyle = (source, isMatched) => {
    if (isMatched) {
      return 'bg-gradient-to-r from-red-50 to-pink-50 text-red-600 border-red-200';
    }

    return 'bg-blue-50 text-blue-600 border-blue-200';
  };
  const formatSourceName = (source) => {
    return source
      ?.toLowerCase()
      .replace(/_/g, ' ')
      .replace(/\b\w/g, (c) => c.toUpperCase());
  };
  const GetAPIcalls = async (url) => {
    const token = localStorage.getItem('jwtToken');
    const apiUrl = `${BASE_URL}${url}`;
    const headers = {
      'Content-Type': 'application/json',
    };
    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    try {
      const response = await fetch(apiUrl, {
        method: 'GET',
        headers,
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
          throw new Error('Session expired. Please log in again.');
        }
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
        }));
        throw new Error(errorData.message || 'Something went wrong');
      }
      return await response.json();
    } catch (error) {
      console.error('API Call Error:', error); // Log full error for debugging
      throw new Error(
        typeof error.message === 'string'
          ? error.message
          : 'Network error, please try again later',
      );
    }
  };
  function formatDateTime(dateString) {
    if (!dateString) return '-';

    try {
      // remove timezone abbreviations like AEDT, AEST etc.
      const cleaned = dateString.replace(/\b[A-Z]{3,4}\b/g, '').trim();

      const parts = cleaned.split(' ');
      const [day, month, year] = parts[0].split('/');

      let [hour] = parts[1].split(':');
      const period = parts[2];

      hour = parseInt(hour);

      // convert 12h → 24h
      if (period === 'PM' && hour !== 12) hour += 12;
      if (period === 'AM' && hour === 12) hour = 0;

      return `${day}/${month}/${year}`;
    } catch (e) {
      return '-';
    }
  }
  const getComplianceStatus = () => {
    if (!decision) return { label: '-', color: 'text-gray-500', sub: '' };

    if (!decision.pep && !decision.sanctions && !decision.adverse_media) {
      return {
        label: 'Clear',
        color: 'text-green-600',
        sub: uiMessage || 'No risk detected',
      };
    }

    if (decision.sanctions) {
      return {
        label: 'High Risk',
        color: 'text-red-600',
        sub: 'Sanctions match found',
      };
    }

    return {
      label: 'Review Required',
      color: 'text-amber-600',
      sub: 'Further checks recommended',
    };
  };

  const compliance = getComplianceStatus();
  const getStatusSanction = (val) => (val ? 'found' : 'completed');

  const sanctionsStatus = getStatusSanction(decision?.sanctions);
  const pepStatus = getStatusSanction(decision?.pep);
  const adverseStatus = getStatusSanction(decision?.adverse_media);
  const getAllDetails = async () => {
    try {
      const response = await GetAPIcalls(
        roleName == 'agent'
          ? `/api/v1/agent/customers/review/${customerId}`
          : `/api/v1/agency/customers/review/${customerId}`,
      );

      if (response.status == 200) {
        // Open account status
        setFirstNameSignup(
          response.data.open_account_information.first_name.value,
        );
        setUserStatus(response.data.status.id);
        setLastNameSignup(
          response.data.open_account_information.last_name.value,
        );
        setEmail(response.data.open_account_information.email_address.value);
        setMobileNumber(
          response.data.open_account_information.country_code.value +
            response.data.open_account_information.mobile_number.value,
        );
        setCustomerType(
          response.data.open_account_information.account_type.value,
        );
        setCustomerStatus(response.data.open_account_information.status.value);
        setHasCertificate(response.data.certificates);
        setOnboardingSections(response.data.onboarding_sections || []);
        if (response.data.status.id != 6) {
          //Personal info
          setProfilePic(
            response.data.personal_information.profile_picture_file,
          );
          setScreening(response.data.screening);
          setFirstName(response.data.personal_information.first_name);
          setAccountType(response.data.personal_information.account_type);
          setApplicantCountry(
            response.data.personal_information.applicant_country,
          );
          setSocialSecurityNumber(
            response.data.personal_information.social_security_number,
          );
          setLastName(response.data.personal_information.last_name);
          setMiddleName(response.data.personal_information.middle_name);
          setNameFromBirth(response.data.personal_information.is_birth_name);
          setFullName(response.data.personal_information.first_name);
          setFormerNames(response.data.personal_information.former_names);
          const date = new Date(response.data.personal_information.dob.value);
          const formattedDate = date.toLocaleDateString('en-GB');
          setDob(response.data.personal_information.dob);
          setFormattedDOB(formattedDate);
          setRedAddress(response.data.personal_information.address);
          setClientNo(response.data.open_account_information.client_id);
          if (roleName == 'agency_compliance') {
            setMeetingData(response.data.agent_meeting_flags);
          }

          if (
            response.data.personal_information.account_type.id != 1 &&
            response.data.personal_information.account_type.id != 5
          ) {
            setJointAccountID(
              response.data.personal_information.joint_account.unique_id,
            );
            // Invites
            if (
              response.data.personal_information.joint_account.invitations
                .length > 0
            ) {
              const transformed =
                response.data.personal_information.joint_account.invitations.map(
                  (item) => {
                    const apiAddress = item.address;

                    // Safely transform backend address to the structure your component expects
                    const formattedAddress = apiAddress
                      ? {
                          full: apiAddress.google_address || '',
                          street: apiAddress.street_number
                            ? `${apiAddress.street_number} ${
                                apiAddress.street_name || ''
                              }`.trim()
                            : apiAddress.address_line_1 || '',
                          route: apiAddress.address_line_2 || '',
                          city: apiAddress.city?.name || '',
                          state: apiAddress.state?.name || '',
                          country: apiAddress.country?.name || '',
                          zip: apiAddress.postal_code || '',
                          comments: apiAddress.comments,
                          rejection_comment: apiAddress.rejection_comment,
                          rejection_reason: apiAddress.rejection_reason,
                          status: apiAddress.status,
                        }
                      : {
                          full: '',
                          street: '',
                          route: '',
                          city: '',
                          state: '',
                          country: '',
                          zip: '',
                        };

                    return {
                      firstName: item.invitee_first_name || '',
                      lastName: item.invitee_last_name || '',
                      email: item.invitee_email || '',
                      countryCode: item.invitee_country_code || 'AU(+61)',
                      mobile: item.invitee_mobile_number || '',
                      address: formattedAddress,
                      errors: {
                        email: '',
                        mobile: '',
                      },
                    };
                  },
                );

              setJointAccountMembers(transformed);
            }
            // Members
            if (
              response.data.personal_information.joint_account.members.length >
              0
            ) {
              /* FIX (joint members): keep every member (the old
                 is_invitee-only filter hid the managing member) and carry
                 each member's API status { id, label } so the table can
                 show the current status with a View Review Application
                 action. Records without a member row (id === null) or
                 without a user_id are not shown. Field access tolerates
                 both the { value }-wrapped and plain shapes. */
              const transformed =
                response.data.personal_information.joint_account.members
                  .filter(
                    (item) =>
                      item.id !== null &&
                      item.user_id != null &&
                      item.user_id !== '',
                  )
                  .map((item) => {
                    return {
                      firstName:
                        (item.first_name?.value ?? item.first_name) || '',
                      lastName: (item.last_name?.value ?? item.last_name) || '',
                      email: (item.email?.value ?? item.email) || '',
                      userId: item.user_id || '',
                      memberStatus: item.status?.label ?? null,
                    };
                  });
              setJointAccountActualMembers(transformed);
            }

            /* FIX (sole signatory): build the signatory list from BOTH the
               members list (is_sole_signatory) and the invitation list
               (proposed_is_sole_signatory). This block deliberately sits
               outside the `members.length > 0` guard, because the only
               signatory may exist solely as a pending invitation.
               Field access tolerates both the { value }-wrapped and the
               plain shapes returned by the API. */
            {
              const jointAccount =
                response.data.personal_information.joint_account || {};
              const unwrap = (field) =>
                field && typeof field === 'object' && 'value' in field
                  ? field.value
                  : field;
              const buildName = (first, last) =>
                [unwrap(first), unwrap(last)]
                  .filter((part) => part != null && `${part}`.trim() !== '')
                  .join(' ')
                  .trim();

              const memberSignatories = (jointAccount.members || [])
                .filter((item) => unwrap(item.is_sole_signatory) === true)
                .map((item) => ({
                  name:
                    buildName(item.first_name, item.last_name) ||
                    unwrap(item.email) ||
                    '—',
                  email: unwrap(item.email) || '',
                  userId: unwrap(item.user_id) || '',
                  source: 'member',
                  isPending: false,
                }));

              const invitedSignatories = (jointAccount.invitations || [])
                .filter(
                  (item) => unwrap(item.proposed_is_sole_signatory) === true,
                )
                .map((item) => ({
                  name:
                    buildName(
                      item.invitee_first_name,
                      item.invitee_last_name,
                    ) ||
                    unwrap(item.invitee_email) ||
                    '—',
                  email: unwrap(item.invitee_email) || '',
                  userId: unwrap(item.invitee_user_id) || '',
                  source: 'invitation',
                  // status 0 === invitation sent / not yet accepted
                  isPending: unwrap(item.status) !== 1,
                }));

              /* De-duplicate: once an invitee accepts they appear in BOTH
                 lists, so prefer the member row (match on user id, then
                 on lowercased email). */
              const seen = new Set();
              const combined = [
                ...memberSignatories,
                ...invitedSignatories,
              ].filter((entry) => {
                const key =
                  (entry.userId && `id:${entry.userId}`) ||
                  (entry.email && `email:${entry.email.toLowerCase()}`) ||
                  `name:${entry.name.toLowerCase()}`;
                if (seen.has(key)) return false;
                seen.add(key);
                return true;
              });

              setSignatories(combined);
            }
            setSignatory(
              response.data.personal_information.is_any_sole_signatory == true
                ? 'yes'
                : 'no',
            );
            setFileAttorney(
              response.data.personal_information.power_of_attorney_file,
            );
          }

          //Business info
          if (response.data.personal_information.account_type.id == 5) {
            setTaxResidentCountry(
              response.data.business_information.tax_resident_country,
            );
            setNonResCountryText(response.data.business_information.country);
            setBusinessRegistrationNumber(
              response.data.business_information.business_registration_number,
            );
            setAbn(response.data.business_information.abn);
            setTaxId(response.data.business_information.tax_id);
            setBusinessName(response.data.business_information.business_name);
            setBusinessActivity(
              response.data.business_information.business_activity,
            );
            setFundSource(response.data.business_information.source_of_funds);
            setAccountPurpose(
              response.data.business_information.purpose_of_opening_account,
            );
            setFilePurpose(response.data.business_information.documents[0]);
            setBusinessAddress(response.data.business_information.address);
            setTransactionNature(
              response.data.business_information
                .nature_n_level_of_intended_transactions,
            );
            setOwnership(
              response.data.business_information
                .beneficial_ownership_with_ratified,
            );
          }

          // //Prove you
          setImage(response.data?.liveness_proof?.selfie);
          setLivenessConfirmed(response.data?.liveness_proof?.has_met_customer);

          // // Upload docs
          setThirdPartySign(
            response.data.proof_documents?.has_prosecution_history,
          );
          setDescription(
            response.data.proof_documents?.prosecution_description,
          );
          setFileProof(response.data.proof_documents?.prosecution_file);
          const proofDocuments = response.data.proof_documents || {};
          setAdditionalDocuments(proofDocuments.additional_documents || []);
          setAdditionalPhotographicDocuments(
            (proofDocuments.photographic_documents || []).slice(1),
          );
          setExpiryDate(
            response.data.proof_documents?.photographic_documents[0]
              ?.expiry_date,
          );
          if (
            response.data.personal_information.applicant_country.value.id == 14
          ) {
            setExpiryDate(
              response.data.proof_documents?.photographic_documents[0]
                ?.expiry_date,
            );
            setphotoId(
              response.data.proof_documents.photographic_documents[0]
                .document_type.value.id,
            );
            setDocumentNumber(
              response.data.proof_documents.photographic_documents[0]
                .document_number,
            );
            setCardNumber(
              response.data.proof_documents.photographic_documents[0]
                ?.card_number,
            );
            setPhotoIdText(
              response.data.proof_documents.photographic_documents[0]
                .document_type.value.name,
            );

            if (
              response.data.proof_documents.photographic_documents[0]
                .document_type.value.id != 2
            ) {
              setFilePhotographicId(
                response.data.proof_documents.photographic_documents[0].file,
              );
            }
            if (
              response.data.proof_documents.photographic_documents[0]
                .document_type.value.id == 2
            ) {
              setFileDriverLinsenceFront(
                response.data.proof_documents.photographic_documents[0].file,
              );
              setFileDriverLinsenceBack(
                response.data.proof_documents.photographic_documents[0]
                  .back_file,
              );
            }
            setIssuedCountry(
              response.data.proof_documents.photographic_documents[0]
                ?.country_of_issue ?? null,
            );
            /* FIX (passport state_of_issue): country_of_issue /
               state_of_issue can be null (e.g. passports) — guard the
               dereference so the review page does not crash. */
            if (
              response.data.proof_documents.photographic_documents[0]
                ?.country_of_issue?.value?.id == 14
            ) {
              setIssuedState(
                response.data.proof_documents.photographic_documents[0]
                  ?.state_of_issue ?? null,
              );
            }
          }

          if (
            response.data.personal_information.applicant_country.value.id != 14
          ) {
            console.log(
              'sjsjjs' +
                response.data.proof_documents.photographic_documents[0]
                  .document_type.value.id,
            );
            setIssuedCountry(
              response.data.proof_documents.photographic_documents[0]
                ?.country_of_issue ?? null,
            );
            /* FIX (passport state_of_issue): guard nulls — and the second
               photographic document may not exist yet. */
            if (
              response.data.proof_documents.photographic_documents[0]
                ?.country_of_issue?.value?.id == 14
            ) {
              setIssuedState(
                response.data.proof_documents.photographic_documents[0]
                  ?.state_of_issue ?? null,
              );
            }
            setIssuedCountrySecond(
              response.data.proof_documents.photographic_documents[1]
                ?.country_of_issue ?? null,
            );
            if (
              response.data.proof_documents.photographic_documents[1]
                ?.country_of_issue?.value?.id == 14
            ) {
              setIssuedStateSecond(
                response.data.proof_documents.photographic_documents[1]
                  ?.state_of_issue ?? null,
              );
            }
            setphotoIdFirst(
              response.data.proof_documents.photographic_documents[0]
                .document_type.value.id,
            );
            setphotoIdFirstText(
              response.data.proof_documents.photographic_documents[0]
                .document_type.value.name,
            );
            if (response.data.proof_documents.photographic_documents[1]) {
              setphotoIdSecond(
                response.data.proof_documents.photographic_documents[1]
                  .document_type.value.id,
              );
              setphotoIdSecondText(
                response.data.proof_documents.photographic_documents[1]
                  .document_type.value.name,
              );
              setDocumentNumberSecond(
                response.data.proof_documents.photographic_documents[1]
                  .document_number,
              );
              setCardNumberSecond(
                response.data.proof_documents.photographic_documents[1]
                  ?.card_number,
              );
              setExpiryDateSecond(
                response.data.proof_documents.photographic_documents[1]
                  .expiry_date,
              );
            }

            setDocumentNumber(
              response.data.proof_documents.photographic_documents[0]
                .document_number,
            );
            setCardNumber(
              response.data.proof_documents.photographic_documents[0]
                ?.card_number,
            );
            setExpiryDate(
              response.data.proof_documents.photographic_documents[0]
                .expiry_date,
            );

            if (
              response.data.proof_documents.photographic_documents[0]
                .document_type.value.id != 2
            ) {
              setfilePhotographicIdFirst(
                response.data.proof_documents.photographic_documents[0].file,
              );
            }
            if (
              response.data.proof_documents.photographic_documents[0]
                .document_type.value.id == 2
            ) {
              setFileDriverLinsenceFrontFirst(
                response.data.proof_documents.photographic_documents[0].file,
              );
              setFileDriverLinsenceBackFirst(
                response.data.proof_documents.photographic_documents[0]
                  .back_file,
              );
            }
            if (
              response.data.proof_documents.photographic_documents[1] &&
              response.data.proof_documents.photographic_documents[1]
                .document_type.value.id != 2
            ) {
              setfilePhotographicIdSecond(
                response.data.proof_documents.photographic_documents[1].file,
              );
            }
            if (
              response.data.proof_documents.photographic_documents[1] &&
              response.data.proof_documents.photographic_documents[1]
                .document_type.value.id == 2
            ) {
              setFileDriverLinsenceFrontSecond(
                response.data.proof_documents.photographic_documents[1].file,
              );
              setFileDriverLinsenceBackSecond(
                response.data.proof_documents.photographic_documents[1]
                  .back_file,
              );
            }
          }
          setNonPhotoIdText(
            response.data.proof_documents.non_photogenic_id_type_name,
          );
          setfileNonPhotographicId(
            response.data.proof_documents.non_photogenic_file,
          );
          setVerificationStatus(
            response.data.dvs_checks?.latest?.verification_result_code,
          );

          setDvsMeessage(
            response.data.dvs_checks?.latest?.verification_result_message,
          );

          setDvsTime(response.data.dvs_checks?.latest?.created_at);
          setSanctionResults(response.data.sanctions_checks);
          setIsDataAvailable(true);
        }
      }
    } catch (err) {
      setIsDataAvailable(false);
      showToast(err.message, 'error');
    } finally {
      //    setIsDataAvailable(true);
    }
  };
  const getEddResponses = async () => {
    try {
      const response = await GetAPIcalls(
        roleName == 'agent'
          ? `/api/v1/agent/customers/review/${customerId}/edd-responses`
          : `/api/v1/agency/customers/review/${customerId}/edd-responses`,
      );
      if (response.status == 200) {
        setEddResponse(response.data);
      }
    } catch (err) {
      setEddResponse({});
      showToast(err.message, 'error');
    }
  };
  const getStatus = async () => {
    try {
      setLoading(true);
      const response = await GetAPIcalls(
        roleName == 'agent'
          ? `/api/v1/agent/customers/review/${customerId}/sections`
          : `/api/v1/agency/customers/review/${customerId}/sections`,
      );

      if (response.status == 200) {
        setStatusData(response.data.sections);
      }
    } catch (err) {
      setStatusData([]);
      showToast(err.message, 'error');
    } finally {
      setTimeout(() => {
        setLoading(false);
      }, 300);
    }
  };
  const getVerifications = async () => {
    try {
      setLoading(true);
      const response = await GetAPIcalls(
        `/api/v1/agency/customers/review/${customerId}/verifications`,
      );

      if (response.status == 200) {
        //   setStatusData(response.data.sections);
      }
    } catch (err) {
      //setStatusData([]);
      showToast(err.message, 'error');
    } finally {
      setTimeout(() => {
        setLoading(false);
      }, 300);
    }
  };
  const getOverallJourney = async () => {
    try {
      const response = await GetAPIcalls(
        roleName == 'agent'
          ? `/api/v1/agent/customers/review/${customerId}/overall-status`
          : `/api/v1/agency/customers/review/${customerId}/overall-status`,
      );
      const stageIconMap = {
        application_submitted: 'description',
        sanction_verification: 'gavel',
        identity_verification: 'verified_user',
        manual_review: 'manage_search',
        approved: 'check_circle',
        rejected: 'cancel',
        resubmission: 'refresh',
      };
      if (response.status == 200) {
        const stages = response.data?.stages || [];

        const mappedStages = stages.map((item) => ({
          ...item,
          key: item.stage,
          icon: stageIconMap[item.stage] || 'circle',
        }));

        setSteps(mappedStages);
      }
    } catch (err) {
      setStatusData([]);
      showToast(err.message, 'error');
    } finally {
      setTimeout(() => {
        setLoading(false);
      }, 300);
    }
  };

  /* ------------------------------------------------------------------ */
  /*  Section approval — "Approve this section" approves EVERY field in  */
  /*  that section. This replaces the old per-section StatusDropdown     */
  /*  calls that were commented out in the section headers.              */
  /*  NOTE: adjust the endpoint / payload below to match your backend    */
  /*  (same base pattern as the other review APIs in this file).         */
  /* ------------------------------------------------------------------ */
  const updateSectionStatus = async (sectionId) => {
    const token = localStorage.getItem('jwtToken');
    const headers = {
      'Content-Type': 'application/json',
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const apiUrl = `${BASE_URL}/api/v1/agency/customers/review/${customerId}/complete-section`;

    const bodyData = {
      section_id: sectionId,
      action: 'approve',
      user_id: customerId,
    };

    try {
      const response = await fetch(apiUrl, {
        method: 'PUT',
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
          throw new Error('Session expired. Please log in again.');
        }
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
        }));

        throw new Error(errorData.message || 'Something went wrong');
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || 'Network error, please try again later');
    }
  };

  const handleApproveSection = useCallback(
    debounce(async (sectionKey, sectionId) => {
      if (!sectionId) return;
      let toastMessage = null;
      try {
        const response = await updateSectionStatus(sectionId);
        if (response.status == 200) {
          toastMessage = {
            message: response.message || 'Section approved successfully',
            type: 'success',
          };
          getStatus(); // refresh the section status grid
          getAllDetails();
        } else {
          toastMessage = { message: response.message, type: 'error' };
        }
      } catch (error) {
        toastMessage = { message: error.message, type: 'error' };
      } finally {
        setLoadingUpdate(false);
        setApprovingSection(null);
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 500);
        }
      }
    }, 1000),
    [customerId],
  );
  const updateApplication = async (action) => {
    const token = localStorage.getItem('jwtToken');
    const headers = {
      'Content-Type': 'application/json',
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const apiUrl =
      roleName == 'agent'
        ? action == 'approve'
          ? `${BASE_URL}/api/v1/agent/customers/review/${customerId}/approve`
          : action == 'resubmit'
            ? `${BASE_URL}/api/v1/agent/customers/review/${customerId}/send-for-resubmission`
            : `${BASE_URL}/api/v1/agent/customers/review/${customerId}/reject`
        : action == 'approve'
          ? `${BASE_URL}/api/v1/agency/customers/review/${customerId}/approve`
          : action == 'resubmit'
            ? `${BASE_URL}/api/v1/agency/customers/review/${customerId}/send-for-resubmission`
            : `${BASE_URL}/api/v1/agency/customers/review/${customerId}/reject`;

    const bodyData = {
      user_id: customerId,
    };
    try {
      const response = await fetch(apiUrl, {
        method: 'PUT',
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
          throw new Error('Session expired. Please log in again.');
        }
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
        }));

        throw new Error(errorData.message || 'Something went wrong');
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || 'Network error, please try again later');
    }
  };
  const updateLiveness = async () => {
    const token = localStorage.getItem('jwtToken');
    const headers = {
      'Content-Type': 'application/json',
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const apiUrl = `${BASE_URL}/api/v1/agent/customers/review/${customerId}/liveness-proof/meeting-flag`;

    const bodyData = {
      has_met_customer: true,
    };
    try {
      const response = await fetch(apiUrl, {
        method: 'PUT',
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
          throw new Error('Session expired. Please log in again.');
        }
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
        }));

        throw new Error(errorData.message || 'Something went wrong');
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || 'Network error, please try again later');
    }
  };
  const sendReverificationAPI = async () => {
    const token = localStorage.getItem('jwtToken');
    const headers = {
      'Content-Type': 'application/json',
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const apiUrl = `${BASE_URL}/api/v1/agency/customers/review/${customerId}/request-reverification`;
    // ✅ extract only IDs
    const sectionIds = statusData?.map((section) => section.id) || [];

    const bodyData = {
      sections: sectionIds,
    };

    try {
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
          throw new Error('Session expired. Please log in again.');
        }
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
        }));

        throw new Error(errorData.message || 'Something went wrong');
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || 'Network error, please try again later');
    }
  };
  const handleSendReverification = useCallback(
    debounce(async () => {
      let toastMessage = null;
      try {
        const response = await sendReverificationAPI();
        if (response.status == 200) {
          toastMessage = {
            message: response.message,
            type: 'success',
          };
        } else {
          toastMessage = { message: response.message, type: 'error' };
        }
      } catch (error) {
        toastMessage = { message: error.message, type: 'error' };
      } finally {
        setLoadingUpdate(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 1000); // Small delay if needed
        }
      }
    }, 1000),
    [customerId], // Dependencies
  );
  const handleUpdateApplication = useCallback(
    debounce(async (e, action) => {
      e.preventDefault();
      let toastMessage = null;
      try {
        const response = await updateApplication(action);
        if (response.status == 200) {
          toastMessage = {
            message: response.message,
            type: 'success',
          };
          if (roleName == 'compliance_officer') {
            navigate('/customer-list', { state: { componentName: 'agency' } });
          } else {
            navigate('/customer-list');
          }
        } else {
          toastMessage = { message: response.message, type: 'error' };
        }
      } catch (error) {
        toastMessage = { message: error.message, type: 'error' };
      } finally {
        setLoadingUpdate(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 1000); // Small delay if needed
        }
      }
    }, 1000),
    [customerId], // Dependencies
  );
  const handleUpdateLivenessCheck = useCallback(
    debounce(async (e) => {
      e.preventDefault();
      let toastMessage = null;
      try {
        const response = await updateLiveness();
        if (response.status == 200) {
          toastMessage = {
            message: 'Details updated successfully',
            type: 'success',
          };
          setLivenessConfirmed(true);
        } else {
          toastMessage = { message: response.message, type: 'error' };
        }
      } catch (error) {
        setLivenessConfirmed(false);
        toastMessage = { message: error.message, type: 'error' };
      } finally {
        setLoadingUpdate(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 1000); // Small delay if needed
        }
      }
    }, 1000),
    [customerId], // Dependencies
  );
  const handleFileClick = (docData) => {
    setcurrentDocument(docData);
    setIsModalOpen(true);
  };
  const handleStatusClick = (docData, fieldText, fieldValue, fieldType) => {
    setCurrentField(docData);
    setCurrentFieldName(fieldText);
    setCurrentFieldValue(fieldValue);
    setCurrentFieldType(fieldType);
    setShowPopup(true);
  };
  const kycheaders = ['', 'Full Name', 'Email Address', 'Mobile Number'];
  const memberHeaders = [
    '',
    'First name',
    'Last name',
    'Email Address',
    'Status',
    'Action',
  ];

  /* Opens the member's review application page (same navigation as the
     first-name link). Only rendered when the member's API status is past
     onboarding/pending — see canViewReviewApplication. */
  const handleViewReviewApplication = (member) => {
    const redirectState = {
      path: `/review-kyc-jointaccount/${member.userId}`,
      state: {
        from: location.pathname,
        historyStack: [
          ...(location.state?.historyStack || []),
          location.pathname,
        ],
      },
    };
    sessionStorage.setItem('redirectAfterLogin', JSON.stringify(redirectState));
    navigate(`/review-kyc-jointaccount/${member.userId}`, {
      state: {
        from: location.pathname,
        historyStack: [
          ...(location.state?.historyStack || []),
          location.pathname,
        ],
      },
    });
  };
  const secondheadersWithAddress = [
    '',
    'First Name',
    'Last Name',
    'Email Address',
    'Mobile Number',
    'Residential Address',
  ];

  useEffect(() => {
    if (customerId || updateFieldStatus) {
      getStatus();
      getAllDetails();
      getOverallJourney();
      getVerifications();
    }
  }, [customerId, updateFieldStatus]);

  useEffect(() => {
    if (customerId) {
      getEddResponses();
    }
  }, [customerId]);

  /* Map each collapsible section to its API section entry. The details
     response includes `onboarding_sections` with a `section` key
     (PERSONAL_INFORMATION, PROVE_ITS_YOU, UPLOAD_PROOF_DOCS, ...);
     the /sections list (statusData) is used as a fallback. */
  const isBusinessCustomer = customerType?.id == 5;
  const allSections =
    onboardingSections && onboardingSections.length
      ? onboardingSections
      : statusData || [];
  const sectionFor = (key, fallback) => {
    const match = allSections.find(
      (s) => String(s?.section || '').toUpperCase() === key,
    );
    return match || fallback || null;
  };
  const sectionMap = {
    personal: sectionFor('PERSONAL_INFORMATION', statusData[0]),
    business: isBusinessCustomer
      ? sectionFor('BUSINESS_INFORMATION', statusData[1])
      : null,
    liveness: sectionFor(
      'PROVE_ITS_YOU',
      isBusinessCustomer ? statusData[2] : statusData[1],
    ),
    proof: sectionFor(
      'UPLOAD_PROOF_DOCS',
      isBusinessCustomer ? statusData[3] : statusData[2],
    ),
  };

  return (
    <div className="lg:min-w-[78vw] lg:max-w-[80vw] p-4 bg-white rounded-lg shadow-lg  relative">
      {loadingUpdate && (
        <div className="fixed top-0 left-0 w-full h-full flex justify-center items-center bg-black bg-opacity-50 z-[999]">
          <div className="w-12 h-12 border-4 border-white border-t-transparent rounded-full animate-spin"></div>
        </div>
      )}
      {loading ? (
        <div className="space-y-6">
          {/* Content Shimmer */}
          {[...Array(5)].map((_, idx) => (
            <div key={idx} className="flex items-center gap-3">
              <div className="w-8 h-8 rounded-full bg-gray-300 animate-shimmer"></div>
              <div className="h-4 w-full max-w-3xl bg-gray-300 rounded animate-shimmer"></div>
            </div>
          ))}

          {/* Buttons Shimmer */}
          <div className="flex flex-wrap gap-2 mt-4">
            <div className="h-10 w-48 bg-gray-300 rounded-xl animate-shimmer"></div>
            <div className="h-10 w-56 bg-gray-300 rounded-xl animate-shimmer"></div>
          </div>
        </div>
      ) : (
        <>
          <div className="flex flex-wrap justify-between items-center mb-4 border-b pb-5 border-gray-100">
            <div className="flex items-center">
              <img src="/note-2.svg" alt="Company Logo" className="mr-3" />
              <span className="font-medium lg:text-lg text-sm">Review KYC</span>
            </div>
            <div className="flex space-x-2 w-full md:w-auto">
              {hasCertificate?.count > 0 && (
                <button
                  onClick={() => {
                    setLoadingUpdate(true);
                    handleSendReverification();
                  }}
                  className="flex text-sm font-medium items-center text-black bg-white border py-2 lg:px-4 px-1 rounded-xl w-full md:w-auto"
                >
                  <span
                    className={`material-symbols-outlined mr-2 text-xl transition-all duration-300 text-black`}
                  >
                    autorenew
                  </span>
                  <span className="inline pr-2">Send for Reverification</span>
                </button>
              )}
              <button
                onClick={() => {
                  setIsActivityLogOpen(true);
                }}
                className="flex text-sm font-medium items-center text-black bg-white border py-2 lg:px-4 px-1 rounded-xl w-full md:w-auto"
              >
                <img
                  src="/backward-10-seconds.svg"
                  alt="Add Icon"
                  className="mr-2"
                />
                <span className="inline pr-2">Activity Log</span>
              </button>
            </div>
          </div>

          <div>
            <div className="w-full p-4">
              {/* Open account information — static, non-collapsible section */}
              <section className="w-full overflow-hidden rounded-2xl border border-slate-200/90 bg-white shadow-[0_1px_2px_rgba(15,23,42,.04),0_20px_48px_-32px_rgba(15,23,42,.35)]">
                <div className="flex w-full flex-wrap items-center justify-between gap-x-4 gap-y-2 px-4 py-3.5 sm:px-5">
                  <div className="flex min-w-0 items-center gap-3">
                    <span
                      className="flex h-9 w-9 shrink-0 items-center justify-center rounded-[10px]"
                      style={{ background: '#375AE714', color: '#375AE7' }}
                    >
                      <svg
                        width="17"
                        height="17"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="1.9"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        aria-hidden="true"
                      >
                        <circle cx="10" cy="7.6" r="3.2" />
                        <path d="M3.6 19.2a6.4 6.4 0 0 1 12.8 0" />
                        <path d="M16.4 4.9a3.2 3.2 0 0 1 0 5.4" />
                        <path d="M20.2 19.1a6.3 6.3 0 0 0-3.6-5.7" />
                      </svg>
                    </span>
                    <div className="min-w-0 leading-tight">
                      <h2 className="truncate text-[14.5px] font-bold tracking-tight text-slate-800">
                        Open Account Information
                      </h2>
                      <p className="text-[11px] font-medium text-slate-400">
                        Customer details on file
                      </p>
                    </div>
                    {customerType?.name ? (
                      <span className="inline-flex items-center gap-1.5 rounded-full border border-[#DCE3F9] bg-[#EEF1FC] px-2.5 py-[5px] text-[10.5px] font-bold uppercase tracking-[.06em] text-[#375AE7]">
                        <span className="h-1.5 w-1.5 rounded-full bg-[#375AE7]" />
                        {customerType.name}
                      </span>
                    ) : null}
                  </div>
                </div>
                <div className="border-t border-slate-100">
                  {/* ---- Fields (full width) ---- */}
                  <dl className="grid w-full grid-cols-1 gap-x-8 gap-y-4 px-4 py-4 sm:grid-cols-2 sm:px-5 lg:grid-cols-4">
                    {/* First Name */}
                    <div className="min-w-0">
                      <dt className="mb-1 flex items-center gap-1.5 text-[10.5px] font-semibold uppercase tracking-[.06em] text-slate-500">
                        <span className="h-1 w-1 rounded-full bg-slate-300" />{' '}
                        First name
                      </dt>
                      <dd className="break-words text-[13.5px] font-medium leading-snug text-slate-700">
                        {firstNameSignup || '—'}
                      </dd>
                    </div>

                    {/* Last Name */}
                    <div className="min-w-0">
                      <dt className="mb-1 flex items-center gap-1.5 text-[10.5px] font-semibold uppercase tracking-[.06em] text-slate-500">
                        <span className="h-1 w-1 rounded-full bg-slate-300" />{' '}
                        Last name
                      </dt>
                      <dd className="break-words text-[13.5px] font-medium leading-snug text-slate-700">
                        {lastNameSignup || '—'}
                      </dd>
                    </div>

                    {/* Email */}
                    <div className="min-w-0">
                      <dt className="mb-1 flex items-center gap-1.5 text-[10.5px] font-semibold uppercase tracking-[.06em] text-slate-500">
                        <span className="h-1 w-1 rounded-full bg-slate-300" />{' '}
                        Email
                      </dt>
                      <dd className="break-all text-[13.5px] font-medium leading-snug text-slate-700">
                        {email || '—'}
                      </dd>
                    </div>

                    {/* Mobile */}
                    <div className="min-w-0">
                      <dt className="mb-1 flex items-center gap-1.5 text-[10.5px] font-semibold uppercase tracking-[.06em] text-slate-500">
                        <span className="h-1 w-1 rounded-full bg-slate-300" />{' '}
                        Mobile
                      </dt>
                      <dd className="break-words text-[13.5px] font-medium leading-snug text-slate-700">
                        {mobileNumber || '—'}
                      </dd>
                    </div>
                  </dl>
                </div>
              </section>
            </div>
            {isActivityLogOpen && (
              <ActivityLog
                onClose={() => setIsActivityLogOpen(false)}
                customerId={customerId}
              />
            )}
            <div className="w-full  p-4">
              <AuditStepper steps={steps} />
            </div>
          </div>
          {userStatus != 6 && (
            <>
              <div className="w-full  p-4">
                <ScreeningPanel screening={screening} />
              </div>
              <div className="w-full  p-4">
                <div className="w-full mt-4 rounded-2xl border border-slate-200 bg-white px-4 py-6 md:px-7 md:py-7 shadow-[0_4px_20px_rgba(15,23,42,0.04)]">
                  <SectionStatusGrid sections={statusData} />
                </div>
              </div>
            </>
          )}
          {isDataAvailable && (
            <>
              {showPopup && currentField && (
                <ReviewPopupKYC
                  isOpen={showPopup}
                  currentField={currentField}
                  currentFieldName={currentFieldName}
                  currentFieldValue={currentFieldValue}
                  currentFieldType={currentFieldType}
                  onClose={() => setShowPopup(false)}
                />
              )}
              {/* End  */}
              {/* Personal Information */}
              <div className="w-full  p-4">
                <CollapsibleSection
                  icon={
                    <svg
                      width="17"
                      height="17"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="1.9"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      aria-hidden="true"
                    >
                      <circle cx="12" cy="8" r="3.6" />
                      <path d="M5 19.4a7 7 0 0 1 14 0" />
                    </svg>
                  }
                  accent="#375AE7"
                  title="Personal Information"
                  subtitle="Identity & address on file"
                  section={sectionMap.personal}
                  approving={approvingSection === 'personal'}
                  onApprove={() => {
                    setLoadingUpdate(true);
                    handleApproveSection('personal', sectionMap.personal?.id);
                  }}
                >
                  <div className="columns-1 gap-8 px-4 pb-2 pt-1 sm:px-5 md:columns-3">
                    {/* Profile Picture (only when present) */}
                    {profilePic.value && (
                      <div className="mb-1 flex break-inside-avoid items-start gap-4 py-2.5">
                        <img
                          src={profilePic.value?.presigned_url}
                          alt={`${fullName.value}`}
                          className="h-16 w-16 shrink-0 rounded-full object-cover ring-2 ring-slate-100"
                        />
                        <div className="flex min-w-0 flex-col gap-1.5 pt-1">
                          <div className="flex items-start justify-between gap-3">
                            <label
                              htmlFor="investmentType"
                              className="flex items-center whitespace-normal words-break text-[10.5px] font-semibold uppercase tracking-[.06em] text-slate-500"
                            >
                              Profile Picture
                            </label>
                            <StatusButton
                              status={profilePic.status}
                              count={profilePic.comments?.length}
                              openSection={() =>
                                handleStatusClick(
                                  profilePic,
                                  'Profile Picture',
                                  profilePic.value?.presigned_url,
                                  '',
                                )
                              }
                            />
                          </div>
                        </div>
                      </div>
                    )}

                    <InfoField
                      label="First Name"
                      field={fullName}
                      fieldLabel="First Name"
                      fieldValue={fullName.value}
                      onStatusClick={handleStatusClick}
                      value={fullName.value}
                    />
                    <InfoField
                      label="Last Name"
                      field={lastName}
                      fieldLabel="Last Name"
                      fieldValue={lastName.value}
                      onStatusClick={handleStatusClick}
                      value={lastName.value}
                    />
                    {middleName && middleName.value && (
                      <InfoField
                        label="Middle Name"
                        field={middleName}
                        fieldLabel="Middle Name"
                        fieldValue={middleName.value}
                        onStatusClick={handleStatusClick}
                        value={middleName.value}
                      />
                    )}
                    {formerNames.value && formerNames.value.length > 0 && (
                      <InfoField
                        label="Customer's Former Name(s)"
                        field={formerNames}
                        fieldLabel="Customer's Former Name(s)"
                        fieldValue={formerNames.value}
                        onStatusClick={handleStatusClick}
                        value={formerNames.value}
                      />
                    )}
                    <InfoField
                      label="Date of Birth"
                      field={dob}
                      fieldLabel="Date of Birth"
                      fieldValue={formattedDOB}
                      onStatusClick={handleStatusClick}
                      value={formattedDOB}
                    />
                    <InfoField
                      label="Applicant's Country"
                      field={applicantCountry}
                      fieldLabel="Applicant's Country"
                      fieldValue={applicantCountry.value.name}
                      onStatusClick={handleStatusClick}
                      value={applicantCountry.value.name}
                    />
                    <InfoField
                      label="Residential Address"
                      field={redAddress}
                      fieldLabel="Residential Address"
                      fieldValue={redAddress.value.google_address}
                      onStatusClick={handleStatusClick}
                      value={redAddress.value.google_address}
                    />
                    <div className="mb-1 flex break-inside-avoid flex-col gap-1.5 py-2.5">
                      <label
                        htmlFor="investmentType"
                        className="flex items-center whitespace-normal words-break text-[10.5px] font-semibold uppercase tracking-[.06em] text-slate-500"
                      >
                        Client No
                      </label>
                      {clientNo?.value ? (
                        <div className="text-[13.5px] font-medium leading-snug text-slate-700">
                          {clientNo?.value}
                        </div>
                      ) : null}
                    </div>
                    {accountType &&
                      accountType.id != 1 &&
                      accountType.id != 5 && (
                        <InfoField
                          label="Joint Account ID"
                          value={jointAccountID}
                        />
                      )}
                    {applicantCountry.value.id == 233 && (
                      <InfoField
                        label="Social Security Number"
                        field={socialSecurityNumber}
                        fieldLabel="Social Security Number"
                        fieldValue={socialSecurityNumber.value}
                        onStatusClick={handleStatusClick}
                        value={socialSecurityNumber.value}
                      />
                    )}
                    <div className="mb-1 flex break-inside-avoid flex-col gap-1.5 py-2.5">
                      <div className="flex items-start justify-between gap-3">
                        <label
                          htmlFor="investmentType"
                          className="flex items-center whitespace-normal words-break text-[10.5px] font-semibold uppercase tracking-[.06em] text-slate-500"
                        >
                          Is this name from birth?
                        </label>
                        <StatusButton
                          status={nameFromBirth.status}
                          count={nameFromBirth.comments?.length}
                          openSection={() =>
                            handleStatusClick(
                              nameFromBirth,
                              'Name from Birth',
                              nameFromBirth.value,
                              '',
                            )
                          }
                        />
                      </div>
                      <div className="flex items-center gap-4">
                        <label className="flex items-center text-sm text-slate-700">
                          <input
                            type="radio"
                            name="birthName"
                            value={true}
                            checked={nameFromBirth.value == true}
                            disabled={true}
                            className="w-4 h-4 text-[#46DA55] border-gray-300 focus:ring-[#46DA55]"
                          />
                          <span className="ml-2">Yes</span>
                        </label>

                        <label className="flex items-center text-sm text-slate-700">
                          <input
                            type="radio"
                            name="birthName"
                            value={false}
                            disabled={true}
                            checked={nameFromBirth.value == false}
                            className="w-4 h-4  border-gray-300 focus:ring-[#46DA55]"
                          />
                          <span className="ml-2">No</span>
                        </label>
                      </div>
                    </div>
                  </div>

                  {/* Joint Account Invites */}
                  {accountType.id != 1 && accountType.id != 5 && (
                    <div className="w-full px-4 pb-4 sm:px-5">
                      <div className="overflow-hidden rounded-xl border border-slate-200">
                        <div className="flex items-center justify-between border-b border-slate-100 bg-slate-50/70 px-4 py-2.5">
                          <h3 className="text-[11px] font-bold uppercase tracking-[.08em] text-slate-500">
                            Joint Account Invites
                          </h3>
                          <span className="text-[10.5px] font-semibold text-slate-400">
                            {jointAccountMembers.length} invited
                          </span>
                        </div>
                        <div className="overflow-x-auto">
                          <table className="w-full border-separate border-spacing-0 text-xs">
                            {/* Table Header */}
                            <thead className="text-left text-[10px] uppercase tracking-wide text-slate-400">
                              {accountType.id != 4 && (
                                <tr>
                                  {kycheaders.map((header, index) => (
                                    <th
                                      key={index}
                                      className={`px-3 py-2.5 font-semibold ${
                                        index === 0 ? 'w-8' : 'min-w-[10rem]'
                                      }`}
                                    >
                                      <span>{header}</span>
                                    </th>
                                  ))}
                                </tr>
                              )}
                              {accountType.id == 4 && (
                                <tr>
                                  {secondheadersWithAddress.map(
                                    (header, index) => (
                                      <th
                                        key={index}
                                        className={`px-3 py-2.5 font-semibold ${
                                          index === 0 ? 'w-8' : 'min-w-[10rem]'
                                        }`}
                                      >
                                        <span>{header}</span>
                                      </th>
                                    ),
                                  )}
                                </tr>
                              )}
                            </thead>
                            <tbody className="text-sm font-medium text-slate-800">
                              {jointAccountMembers.length > 0 ? (
                                jointAccountMembers.map((member, idx) => (
                                  <tr
                                    key={idx}
                                    className="border-t border-slate-100 transition-colors hover:bg-slate-50/60"
                                  >
                                    <td className="px-3 py-3 text-[#8C8C8C]">
                                      {(idx + 1).toString().padStart(2, '0')}.
                                    </td>
                                    <td className="px-3 py-3">
                                      <span className="break-words">
                                        {member.firstName}
                                      </span>
                                    </td>
                                    <td className="px-3 py-3">
                                      <span className="break-words">
                                        {member.lastName}
                                      </span>
                                    </td>
                                    <td className="px-3 py-3">
                                      <span className="break-words">
                                        {member.email}
                                      </span>
                                    </td>
                                    <td className="px-3 py-3">
                                      <span className="text-[#888888]">
                                        {member.countryCode}{' '}
                                      </span>
                                      {member.mobile}
                                    </td>
                                    {accountType.id == 4 && (
                                      <td className="px-3 py-3">
                                        <span className="break-words">
                                          {member.address.full}
                                        </span>
                                      </td>
                                    )}
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td
                                    className="px-3 py-6 text-center text-slate-400"
                                    colSpan="7"
                                  >
                                    No results found
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  )}

                  {/* Joint Account Members */}
                  {accountType.id != 1 && accountType.id != 5 && (
                    <div className="w-full px-4 pb-4 sm:px-5">
                      <div className="overflow-hidden rounded-xl border border-slate-200">
                        <div className="flex items-center justify-between border-b border-slate-100 bg-slate-50/70 px-4 py-2.5">
                          <h3 className="text-[11px] font-bold uppercase tracking-[.08em] text-slate-500">
                            Joint Account Members
                          </h3>
                          <span className="text-[10.5px] font-semibold text-slate-400">
                            {jointAccountActualMembers.length} members
                          </span>
                        </div>
                        <div className="overflow-x-auto">
                          <table className="w-full border-separate border-spacing-0 text-xs">
                            {/* Table Header */}
                            <thead className="text-left text-[10px] uppercase tracking-wide text-slate-400">
                              <tr>
                                {memberHeaders.map((header, index) => (
                                  <th
                                    key={index}
                                    className={`px-3 py-2.5 font-semibold ${
                                      index === 0 ? 'w-8' : 'min-w-[10rem]'
                                    }`}
                                  >
                                    <span>{header}</span>
                                  </th>
                                ))}
                              </tr>
                            </thead>
                            <tbody className="text-sm font-medium text-slate-800">
                              {jointAccountActualMembers.length > 0 ? (
                                jointAccountActualMembers.map((member, idx) => (
                                  <tr
                                    key={idx}
                                    className="border-t border-slate-100 transition-colors hover:bg-slate-50/60"
                                  >
                                    <td className="px-3 py-3 text-[#8C8C8C]">
                                      {(idx + 1).toString().padStart(2, '0')}.
                                    </td>
                                    <td className="px-3 py-3">
                                      <span
                                        onClick={() => {
                                          let redirectState = {
                                            path: `/review-kyc-jointaccount/${member.userId}`,
                                            state: {
                                              from: location.pathname,
                                              historyStack: [
                                                ...(location.state
                                                  ?.historyStack || []),
                                                location.pathname,
                                              ],
                                            },
                                          };
                                          sessionStorage.setItem(
                                            'redirectAfterLogin',
                                            JSON.stringify(redirectState),
                                          );
                                          navigate(
                                            `/review-kyc-jointaccount/${member.userId}`,
                                            {
                                              state: {
                                                from: location.pathname,
                                                historyStack: [
                                                  ...(location.state
                                                    ?.historyStack || []),
                                                  location.pathname,
                                                ],
                                              },
                                            },
                                          );
                                        }}
                                        className="break-words underline cursor-pointer"
                                      >
                                        {member.firstName}
                                      </span>
                                    </td>
                                    <td className="px-3 py-3">
                                      <span className="break-words">
                                        {member.lastName}
                                      </span>
                                    </td>
                                    <td className="px-3 py-3">
                                      <span className="break-words">
                                        {member.email}
                                      </span>
                                    </td>
                                    {/* Member status from the API response */}
                                    <td className="px-3 py-3">
                                      {member.memberStatus ? (
                                        <span
                                          className={`inline-flex items-center rounded-full border px-2 py-0.5 text-[10px] font-bold uppercase tracking-wide ${getMemberStatusChipClass(
                                            member.memberStatus,
                                          )}`}
                                        >
                                          {formatMemberStatusLabel(
                                            member.memberStatus,
                                          )}
                                        </span>
                                      ) : (
                                        <span className="text-xs text-slate-400">
                                          —
                                        </span>
                                      )}
                                    </td>
                                    {/* View Review Application action */}
                                    <td className="px-3 py-3">
                                      {canViewReviewApplication(member) ? (
                                        <button
                                          type="button"
                                          onClick={() =>
                                            handleViewReviewApplication(member)
                                          }
                                          className="rounded-full border border-[#375AE7] px-3 py-1 text-[11px] font-semibold text-[#375AE7] transition hover:bg-[#375AE7]/10"
                                        >
                                          View Review Application
                                        </button>
                                      ) : (
                                        <span className="text-xs text-slate-400">
                                          —
                                        </span>
                                      )}
                                    </td>
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td
                                    className="px-3 py-6 text-center text-slate-400"
                                    colSpan="7"
                                  >
                                    No results found
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>

                        {/* Signatory details */}
                        <div className="grid grid-cols-1 gap-3 p-4 md:grid-cols-3">
                          <div className="rounded-xl border border-slate-200 bg-slate-50/50 p-4">
                            <label
                              htmlFor="investmentType"
                              className="whitespace-normal words-break text-[10.5px] font-semibold uppercase tracking-[.06em] text-slate-500"
                            >
                              Is there going to be a Sole Signatory by providing
                              a Power Of Attorney?
                            </label>
                            <div className="mt-2.5 flex items-center gap-4">
                              <label className="flex items-center text-sm text-slate-700">
                                <input
                                  type="radio"
                                  name="signatory"
                                  value="yes"
                                  checked={signatory === 'yes'}
                                  className="w-6 h-4 confirm-check  border-gray-300 focus:ring-[#005a9c]"
                                />
                                <span className="ml-2">Yes</span>
                              </label>

                              <label className="flex items-center text-sm text-slate-700">
                                <input
                                  type="radio"
                                  name="signatory"
                                  value="no"
                                  checked={signatory === 'no'}
                                  className="w-6 h-4 confirm-check  border-gray-300 focus:ring-[#005a9c]"
                                />
                                <span className="ml-2">No</span>
                              </label>
                            </div>
                          </div>

                          <div className="rounded-xl border border-slate-200 bg-slate-50/50 p-4">
                            <label
                              htmlFor="investmentType"
                              className="whitespace-normal words-break text-[10.5px] font-semibold uppercase tracking-[.06em] text-slate-500"
                            >
                              Select which joint account members are going to be
                              the signatories
                            </label>
                            {/* FIX (sole signatory): render every signatory
                                coming from the members list AND the pending
                                invitation list instead of the old hardcoded
                                'Myself' fallback. */}
                            {signatories.length > 0 ? (
                              <ul className="mt-2.5 space-y-1.5">
                                {signatories.map((person, index) => (
                                  <li
                                    key={`${person.source}-${
                                      person.userId || person.email || index
                                    }`}
                                    className="flex flex-wrap items-center gap-2"
                                  >
                                    <span className="text-[13.5px] font-medium text-slate-700">
                                      {person.name}
                                    </span>
                                    {person.email ? (
                                      <span className="text-[11px] text-slate-400">
                                        {person.email}
                                      </span>
                                    ) : null}
                                    {person.isPending ? (
                                      <span className="inline-flex items-center rounded-full border border-amber-200 bg-amber-50 px-2 py-0.5 text-[10px] font-bold uppercase tracking-wide text-amber-700">
                                        Invited
                                      </span>
                                    ) : null}
                                  </li>
                                ))}
                              </ul>
                            ) : (
                              <div className="mt-2.5 text-[13.5px] font-medium text-slate-400">
                                {signatory === 'yes'
                                  ? 'Not selected'
                                  : 'All members are signatories'}
                              </div>
                            )}
                          </div>

                          <div className="rounded-xl border border-slate-200 bg-slate-50/50 p-4">
                            <div className="flex items-start justify-between gap-3">
                              <label
                                htmlFor="investmentType"
                                className="flex items-center whitespace-normal words-break text-[10.5px] font-semibold uppercase tracking-[.06em] text-slate-500"
                              >
                                Power of Attorney
                              </label>
                              <StatusButton
                                status={fileAttorney?.status}
                                count={fileAttorney?.comments?.length}
                                openSection={() =>
                                  handleStatusClick(
                                    fileAttorney,
                                    'Power of Attorney',
                                    fileAttorney.value,
                                    'file',
                                  )
                                }
                              />
                            </div>
                            {fileAttorney && fileAttorney.value && (
                              <div
                                onClick={(e) => {
                                  e.preventDefault();
                                  handleFileClick(fileAttorney.value);
                                }}
                                className="mt-2.5 cursor-pointer rounded-lg border border-slate-200 bg-white px-3 py-2 shadow-sm transition hover:border-[#375AE7]/40 hover:shadow"
                              >
                                <span className="text-slate-800 underline">
                                  {fileAttorney.value.file_name}
                                </span>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </CollapsibleSection>
              </div>
              {/* End  */}
              {/* Business Information */}
              {customerType.id == 5 && (
                <div className="w-full  p-4">
                  <CollapsibleSection
                    icon={
                      <svg
                        width="17"
                        height="17"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="1.9"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        aria-hidden="true"
                      >
                        <rect x="3.5" y="7.5" width="17" height="12" rx="2.5" />
                        <path d="M9 7.5V6a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v1.5" />
                        <path d="M3.5 12.5h17" />
                      </svg>
                    }
                    accent="#8B5CF6"
                    title="Business Information"
                    subtitle="Registered business & funding"
                    section={sectionMap.business}
                    approving={approvingSection === 'business'}
                    onApprove={() => {
                      setLoadingUpdate(true);
                      handleApproveSection('business', sectionMap.business?.id);
                    }}
                  >
                    <div className="columns-1 gap-8 px-4 pb-2 pt-1 sm:px-5 md:columns-3">
                      <InfoField
                        label="Tax Resident Country"
                        field={taxResidentCountry}
                        fieldLabel="Power of Attorney"
                        fieldValue={taxResidentCountry?.value.name}
                        onStatusClick={handleStatusClick}
                        value={taxResidentCountry?.value.name}
                      />
                      {taxResidentCountry?.value.id == 2 && (
                        <InfoField
                          label="Country"
                          field={nonResCountryText}
                          fieldLabel="Country"
                          fieldValue={nonResCountryText.value.name}
                          onStatusClick={handleStatusClick}
                          value={nonResCountryText.value.name}
                        />
                      )}
                      {taxResidentCountry?.value.id != 1 && (
                        <InfoField
                          label="Business Registration Number"
                          field={businessRegistrationNumber}
                          fieldLabel="Business Registration Number"
                          fieldValue={businessRegistrationNumber?.value}
                          onStatusClick={handleStatusClick}
                          value={businessRegistrationNumber?.value}
                        />
                      )}
                      {taxResidentCountry?.value.id == 1 && (
                        <InfoField
                          label="ABN"
                          field={abn}
                          fieldLabel="ABN"
                          fieldValue={abn.value}
                          onStatusClick={handleStatusClick}
                          value={abn.value}
                        />
                      )}
                      {taxResidentCountry?.value.id == 3 && (
                        <InfoField
                          label="Tax ID"
                          field={taxId}
                          fieldLabel="Tax ID"
                          fieldValue={taxId.value}
                          onStatusClick={handleStatusClick}
                          value={taxId.value}
                        />
                      )}
                      <InfoField
                        label="Business Name"
                        field={businessName}
                        fieldLabel="Business Name"
                        fieldValue={businessName?.value}
                        onStatusClick={handleStatusClick}
                        value={businessName?.value}
                      />
                      <InfoField
                        label="Describe the business activity"
                        field={businessActivity}
                        fieldLabel="Describe the business activity"
                        fieldValue={businessActivity?.value.name}
                        onStatusClick={handleStatusClick}
                        value={businessActivity?.value.name}
                        wide
                      />
                      <InfoField
                        label="Source of the funds including its origin"
                        field={fundSource}
                        fieldLabel="Source of the funds including its origin"
                        fieldValue={fundSource.value}
                        onStatusClick={handleStatusClick}
                        value={fundSource?.value}
                        wide
                      />
                      <InfoField
                        label="Purpose of opening account"
                        field={accountPurpose}
                        fieldLabel="Purpose of opening account"
                        fieldValue={accountPurpose?.value}
                        onStatusClick={handleStatusClick}
                        value={accountPurpose?.value}
                        wide
                      />
                      {filePurpose && filePurpose.value && (
                        <div className="mb-1 break-inside-avoid">
                          <div className="flex items-start justify-between gap-3 py-2.5">
                            <label
                              htmlFor="investmentType"
                              className="mt-2 whitespace-normal words-break text-[10.5px] font-semibold uppercase tracking-[.06em] text-slate-500 w-40 md:w-full flex items-center"
                            >
                              Additional documents
                            </label>
                            <StatusButton
                              status={filePurpose.status}
                              count={filePurpose.comments?.length}
                              openSection={() =>
                                handleStatusClick(
                                  filePurpose,
                                  'Additional documents',
                                  filePurpose.value,
                                  'file',
                                )
                              }
                            />
                          </div>
                          <div
                            onClick={(e) => {
                              e.preventDefault();
                              handleFileClick(filePurpose.value);
                            }}
                            className="cursor-pointer rounded-lg border border-slate-200 bg-white px-3 py-2 shadow-sm transition hover:border-[#375AE7]/40 hover:shadow"
                          >
                            <span className="text-slate-800 underline">
                              {filePurpose.value.file_name}
                            </span>
                          </div>
                        </div>
                      )}
                      <InfoField
                        label="Address of Principal Place of Business"
                        field={businessAddress}
                        fieldLabel="Address of Principal Place of Businesss"
                        fieldValue={businessAddress?.value.google_address}
                        onStatusClick={handleStatusClick}
                        value={businessAddress?.value.google_address}
                        wide
                      />
                      <InfoField
                        label="Nature and level of the intended transaction behaviour"
                        field={transactionNature}
                        fieldLabel="Nature and level of the intended transaction behaviour"
                        fieldValue={transactionNature?.value}
                        onStatusClick={handleStatusClick}
                        value={transactionNature?.value}
                        wide
                      />
                      <InfoField
                        label="Beneficial ownership of the funds used by this account"
                        field={ownership}
                        fieldLabel="Beneficial ownership of the funds used by this account"
                        fieldValue={ownership?.value == true ? 'Yes' : 'No'}
                        onStatusClick={handleStatusClick}
                        value={ownership?.value == true ? 'Yes' : 'No'}
                        wide
                      />
                    </div>
                  </CollapsibleSection>
                </div>
              )}
              {/* End  */}
              {/* Image section */}
              <div className="w-full  p-4">
                <CollapsibleSection
                  icon={
                    <svg
                      width="17"
                      height="17"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="1.9"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      aria-hidden="true"
                    >
                      <path d="M14.5 4h-5L7 7H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-3l-2.5-3z" />
                      <circle cx="12" cy="13" r="3" />
                    </svg>
                  }
                  accent="#0EA5E9"
                  title="Prove Its You"
                  subtitle="Liveness & meeting verification"
                  section={sectionMap.liveness}
                  approving={approvingSection === 'liveness'}
                  onApprove={() => {
                    setLoadingUpdate(true);
                    handleApproveSection('liveness', sectionMap.liveness?.id);
                  }}
                >
                  <div className="mt-4 flex flex-col gap-6 px-4 pb-5 pt-1 sm:px-5 md:flex-row">
                    {/* IMAGE SECTION */}
                    <div className="w-full md:max-w-[280px]">
                      <div className="flex items-center justify-between gap-3">
                        <span className="text-[10.5px] font-semibold uppercase tracking-[.06em] text-slate-500">
                          Photo Upload
                        </span>

                        <StatusButton
                          status={image.status}
                          count={image.comments?.length}
                          openSection={() =>
                            handleStatusClick(
                              image,
                              'Photo Upload',
                              image.value.presigned_url,
                              '',
                            )
                          }
                        />
                      </div>

                      <div className="relative mt-2.5 h-44 w-full overflow-hidden rounded-xl border border-slate-200 bg-gray-50">
                        <img
                          src={image.value.presigned_url}
                          alt="Uploaded"
                          className="h-full w-full object-cover"
                        />

                        <button
                          onClick={() => setFullscreen(true)}
                          className="absolute right-2 top-2 rounded-full bg-white/90 p-2 shadow transition hover:bg-white"
                        >
                          <img src="/show-full.svg" className="h-4 w-4" />
                        </button>
                      </div>
                    </div>
                    {/* RIGHT SIDE (STATUS + CONFIRMATION STACKED CLEANLY) */}
                    {roleName === 'agent' && (
                      <div className="flex-1">
                        <div className="flex items-start gap-3 rounded-xl border border-blue-100 bg-blue-50 p-4">
                          <input
                            type="checkbox"
                            checked={livenessConfirmed}
                            onChange={(e) => {
                              setLoadingUpdate(true);
                              handleUpdateLivenessCheck(e);
                            }}
                            disabled={livenessConfirmed}
                            className="mt-1 w-4 h-4 accent-[#375AE7]"
                          />

                          <label className="text-sm leading-relaxed text-gray-800">
                            I confirm the person in the document matches the
                            customer I met in person.
                          </label>
                        </div>
                      </div>
                    )}
                    {roleName === 'agency_compliance' && (
                      <div className="flex-1">
                        {/* Header */}
                        <div className="mb-3 flex items-center justify-between">
                          <h3 className="text-sm font-semibold text-gray-700">
                            Team Member Meeting Status
                          </h3>

                          <span className="text-xs text-gray-400">
                            {meetingData?.length} team members
                          </span>
                        </div>

                        {/* Scrollable container for large lists */}
                        <div className="max-h-[420px] space-y-3 overflow-y-auto pr-2">
                          {meetingData?.map((agent) => (
                            <div
                              key={agent.agent_user_id}
                              className="flex items-center justify-between rounded-xl border border-slate-200 bg-white p-3 transition hover:bg-gray-50"
                            >
                              {/* LEFT: identity */}
                              <div className="flex min-w-0 items-center gap-3">
                                <div className="flex h-9 w-9 items-center justify-center rounded-full bg-gradient-to-br from-indigo-500 to-blue-600 text-sm font-semibold text-white">
                                  {agent.agent_name?.charAt(0) || 'A'}
                                </div>

                                <div className="min-w-0">
                                  <p className="truncate text-sm font-medium text-gray-800">
                                    {agent.agent_name}
                                  </p>
                                  <p className="truncate text-xs text-gray-500">
                                    {agent.agent_email}
                                  </p>
                                </div>
                              </div>

                              {/* RIGHT: status */}
                              <div className="flex items-center gap-3">
                                <span
                                  className={`rounded-full border px-2 py-1 text-[11px] font-medium ${
                                    agent.has_met_customer
                                      ? 'border-green-200 bg-green-50 text-green-600'
                                      : 'border-red-200 bg-red-50 text-red-600'
                                  }`}
                                >
                                  {agent.has_met_customer ? 'Met' : 'Not Met'}
                                </span>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}
                  </div>
                </CollapsibleSection>
              </div>
              {fullscreen && (
                <div
                  className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 px-4 py-6"
                  onClick={() => setFullscreen(false)}
                >
                  <img
                    src={image.value.presigned_url}
                    alt="Fullscreen"
                    className="max-h-full max-w-full rounded-md object-contain shadow-lg"
                  />
                </div>
              )}
              {/* End */}
              {/* Upload Proof Documents */}
              <div className="w-full  p-4">
                <CollapsibleSection
                  icon={
                    <svg
                      width="17"
                      height="17"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="1.9"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      aria-hidden="true"
                    >
                      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                      <path d="M14 2v6h6" />
                      <path d="M9 13h6" />
                      <path d="M9 17h6" />
                    </svg>
                  }
                  accent="#F59E0B"
                  title="Upload Proof Documents"
                  subtitle="Prosecution history & identity documents"
                  section={sectionMap.proof}
                  approving={approvingSection === 'proof'}
                  onApprove={() => {
                    setLoadingUpdate(true);
                    handleApproveSection('proof', sectionMap.proof?.id);
                  }}
                >
                  {/* Prosecution */}
                  <div className="grid grid-cols-1 gap-8 px-4 pb-2 pt-1 sm:px-5 md:grid-cols-2">
                    <div className="flex min-w-0 flex-col">
                      <div className="flex items-start justify-between gap-3 py-2.5">
                        <label
                          htmlFor="investmentType"
                          className="whitespace-normal break-words text-[10.5px] font-semibold uppercase tracking-[.06em] text-slate-500 w-40 md:w-full flex items-center"
                        >
                          Details of any current or recent prosecutions and
                          inquiries related to Money Laundering, terrorist
                          links, tax offences and corruption in respect of the
                          Individual
                        </label>
                        <StatusButton
                          status={thirdPartySign.status}
                          count={thirdPartySign.comments?.length}
                          openSection={() =>
                            handleStatusClick(
                              thirdPartySign,
                              'Details of any current or recent prosecutions and inquiries related to Money Laundering, terrorist links, tax offences and corruption in respect of the Individual',
                              thirdPartySign.value,
                              '',
                            )
                          }
                        />
                      </div>
                      <div className="flex items-center gap-4">
                        <label className="flex items-center text-sm text-slate-700">
                          <input
                            type="radio"
                            name="thirdPartySign"
                            value="yes"
                            checked={thirdPartySign.value === true}
                            className="w-6 comfirm-check h-4 text-[#46DA55] border-gray-300 focus:ring-[#46DA55]"
                          />
                          <span className="ml-2">Yes</span>
                        </label>

                        <label className="flex items-center text-sm text-slate-700">
                          <input
                            type="radio"
                            name="thirdPartySign"
                            value="no"
                            checked={thirdPartySign.value === false}
                            className="w-6 h-4 confirm-check border-gray-300 focus:ring-[#46DA55]"
                          />
                          <span className="ml-2">No</span>
                        </label>
                      </div>
                      {thirdPartySign.value === true && (
                        <InfoField
                          label="Description"
                          field={description}
                          fieldLabel="Description"
                          fieldValue={description.value}
                          onStatusClick={handleStatusClick}
                          value={description.value}
                        />
                      )}
                    </div>
                    {thirdPartySign.value === true && (
                      <div className="flex min-w-0 flex-col">
                        <FileUploadDisplay
                          label="Upload Proof"
                          fileData={fileProof}
                          onFileClick={handleFileClick}
                        />
                      </div>
                    )}
                  </div>
                  {/* Extra details */}
                  <div className="grid grid-cols-1 gap-8 px-4 pb-2 pt-1 sm:px-5 md:grid-cols-3">
                    {/* Photographic ID(s) */}
                    <div className="flex min-w-0 flex-col">
                      {applicantCountry.value.id == 14 && (
                        <>
                          <div className="flex items-start justify-between gap-3 py-2.5">
                            <label
                              htmlFor="investmentType"
                              className="text-[10.5px] font-semibold uppercase tracking-[.06em] text-slate-500 flex items-center"
                            >
                              Photographic ID
                            </label>
                          </div>
                          {photoIdText ? (
                            <div className="text-[13.5px] font-medium text-slate-700">
                              {photoIdText}
                            </div>
                          ) : null}
                          {(photoId == 1 || photoId == 3) && (
                            <>
                              <FileUploadDisplay
                                label={
                                  photoId == 1
                                    ? 'Upload Copy of Passport'
                                    : 'Upload Photo ID issued under a State or Territory law'
                                }
                                fileData={filePhotographicId}
                                onFileClick={handleFileClick}
                              />
                              {photoId == 1 && (
                                <InfoField
                                  label="Passport Number"
                                  field={documentNumber}
                                  fieldLabel="Passport Number"
                                  fieldValue={documentNumber.value}
                                  onStatusClick={handleStatusClick}
                                  value={documentNumber.value}
                                />
                              )}
                              {photoId == 3 && (
                                <InfoField
                                  label="Document Number"
                                  field={documentNumber}
                                  fieldLabel="Document Number"
                                  fieldValue={documentNumber.value}
                                  onStatusClick={handleStatusClick}
                                  value={documentNumber.value}
                                />
                              )}
                            </>
                          )}
                          {photoId == 2 && (
                            <>
                              <FileUploadDisplay
                                label="Upload Copy of Driver's License (Front)"
                                fileData={fileDriverLinsenceFront}
                                onFileClick={handleFileClick}
                              />
                              <FileUploadDisplay
                                label="Upload Copy of Driver's License (Back)"
                                fileData={fileDriverLinsenceBack}
                                onFileClick={handleFileClick}
                              />
                              <InfoField
                                label="Driver's License Number"
                                field={documentNumber}
                                fieldLabel="Driver's License Number"
                                fieldValue={documentNumber.value}
                                onStatusClick={handleStatusClick}
                                value={documentNumber.value}
                              />
                              <InfoField
                                label="Card Number"
                                field={cardNumber}
                                fieldLabel="Card Number"
                                fieldValue={cardNumber.value}
                                onStatusClick={handleStatusClick}
                                value={cardNumber.value}
                              />
                            </>
                          )}
                          <InfoField
                            label="Expiry Date"
                            field={expiryDate}
                            fieldLabel=" Expiry Date"
                            fieldValue={
                              expiryDate
                                ? new Date(expiryDate.value).toLocaleDateString(
                                    'en-GB',
                                  )
                                : ''
                            }
                            onStatusClick={handleStatusClick}
                            value={
                              expiryDate
                                ? new Date(expiryDate.value).toLocaleDateString(
                                    'en-GB',
                                  )
                                : ''
                            }
                          />
                        </>
                      )}
                      {applicantCountry.value.id != 14 && (
                        <>
                          <div className="flex items-start justify-between gap-3 py-2.5">
                            <label
                              htmlFor="investmentType"
                              className="text-[10.5px] font-semibold uppercase tracking-[.06em] text-slate-500 w-40 md:w-full flex items-center"
                            >
                              Select First Photographic ID
                            </label>
                          </div>
                          {photoIdFirstText ? (
                            <div className="text-[13.5px] font-medium text-slate-700">
                              {photoIdFirstText}
                            </div>
                          ) : null}
                          {(photoIdFirst == 1 || photoIdFirst == 3) && (
                            <>
                              <FileUploadDisplay
                                label={
                                  photoIdFirst == 1
                                    ? 'Upload Copy of Passport'
                                    : 'Upload Photo ID issued under a State or Territory law'
                                }
                                fileData={filePhotographicIdFirst}
                                onFileClick={handleFileClick}
                              />
                              {photoIdFirst == 1 && (
                                <InfoField
                                  label="Passport Number"
                                  field={documentNumber}
                                  fieldLabel="Passport Number"
                                  fieldValue={documentNumber.value}
                                  onStatusClick={handleStatusClick}
                                  value={documentNumber.value}
                                />
                              )}
                              {photoIdFirst == 3 && (
                                <InfoField
                                  label="Document Number"
                                  field={documentNumber}
                                  fieldLabel="Document Number"
                                  fieldValue={documentNumber.value}
                                  onStatusClick={handleStatusClick}
                                  value={documentNumber.value}
                                />
                              )}
                            </>
                          )}
                          {photoIdFirst == 2 && (
                            <>
                              <FileUploadDisplay
                                label="Upload Copy of Driver's License (Front)"
                                fileData={fileDriverLinsenceFrontFirst}
                                onFileClick={handleFileClick}
                              />
                              <FileUploadDisplay
                                label="Upload Copy of Driver's License (Back)"
                                fileData={fileDriverLinsenceBackFirst}
                                onFileClick={handleFileClick}
                              />
                              <InfoField
                                label="Driver's License Number"
                                field={documentNumber}
                                fieldLabel="Driver's License Number"
                                fieldValue={documentNumber.value}
                                onStatusClick={handleStatusClick}
                                value={documentNumber.value}
                              />
                              <InfoField
                                label="Card Number"
                                field={cardNumber}
                                fieldLabel="Card Number"
                                fieldValue={cardNumber.value}
                                onStatusClick={handleStatusClick}
                                value={cardNumber.value}
                              />
                            </>
                          )}
                          <InfoField
                            label="Expiry Date"
                            field={expiryDate}
                            fieldLabel="Expiry Date"
                            fieldValue={
                              expiryDate
                                ? new Date(expiryDate.value).toLocaleDateString(
                                    'en-GB',
                                  )
                                : ''
                            }
                            onStatusClick={handleStatusClick}
                            value={
                              expiryDate
                                ? new Date(expiryDate.value).toLocaleDateString(
                                    'en-GB',
                                  )
                                : ''
                            }
                          />
                          <div className="flex items-start justify-between gap-3 py-2.5">
                            <label
                              htmlFor="investmentType"
                              className="text-[10.5px] font-semibold uppercase tracking-[.06em] text-slate-500 w-40 md:w-full flex items-center"
                            >
                              Select Second Photographic ID
                            </label>
                          </div>
                          {photoIdSecondText ? (
                            <div className="text-[13.5px] font-medium text-slate-700">
                              {photoIdSecondText}
                            </div>
                          ) : null}
                          {(photoIdSecond == 1 || photoIdSecond == 3) && (
                            <>
                              <FileUploadDisplay
                                label={
                                  photoIdSecond == 1
                                    ? 'Upload Copy of Passport'
                                    : 'Upload Photo ID issued under a State or Territory law'
                                }
                                fileData={filePhotographicIdSecond}
                                onFileClick={handleFileClick}
                              />
                              {photoIdSecond == 1 && (
                                <InfoField
                                  label="Passport Number"
                                  field={documentNumberSecond}
                                  fieldLabel="Passport Number"
                                  fieldValue={documentNumberSecond.value}
                                  onStatusClick={handleStatusClick}
                                  value={documentNumberSecond.value}
                                />
                              )}
                              {photoIdSecond == 3 && (
                                <InfoField
                                  label="Document Number"
                                  field={documentNumberSecond}
                                  fieldLabel="Document Number"
                                  fieldValue={documentNumberSecond.value}
                                  onStatusClick={handleStatusClick}
                                  value={documentNumberSecond.value}
                                />
                              )}
                            </>
                          )}
                          {photoIdSecond == 2 && (
                            <>
                              <FileUploadDisplay
                                label="Upload Copy of Driver's License (Front)"
                                fileData={fileDriverLinsenceFrontSecond}
                                onFileClick={handleFileClick}
                              />
                              <FileUploadDisplay
                                label="Upload Copy of Driver's License (Back)"
                                fileData={fileDriverLinsenceBackSecond}
                                onFileClick={handleFileClick}
                              />
                              <InfoField
                                label="Driver's License Number"
                                field={documentNumberSecond}
                                fieldLabel="Driver's License Number"
                                fieldValue={documentNumberSecond.value}
                                onStatusClick={handleStatusClick}
                                value={documentNumberSecond.value}
                              />
                              <InfoField
                                label="Card Number"
                                field={cardNumberSecond}
                                fieldLabel="Card Number"
                                fieldValue={cardNumberSecond.value}
                                onStatusClick={handleStatusClick}
                                value={cardNumberSecond.value}
                              />
                            </>
                          )}
                          <InfoField
                            label="Expiry Date"
                            field={expiryDateSecond}
                            fieldLabel="Expiry Date"
                            fieldValue={
                              expiryDateSecond
                                ? new Date(
                                    expiryDateSecond.value,
                                  ).toLocaleDateString('en-GB')
                                : ''
                            }
                            onStatusClick={handleStatusClick}
                            value={
                              expiryDateSecond
                                ? new Date(
                                    expiryDateSecond.value,
                                  ).toLocaleDateString('en-GB')
                                : ''
                            }
                          />
                        </>
                      )}
                    </div>

                    {/* Non Photographic ID (only rendered when applicable — no empty gap) */}
                    {photoId != 2 && (
                      <div className="flex min-w-0 flex-col">
                        <div className="flex items-start justify-between gap-3 py-2.5">
                          <label
                            htmlFor="investmentType"
                            className="text-[10.5px] font-semibold uppercase tracking-[.06em] text-slate-500 w-40 md:w-full flex items-center"
                          >
                            Non Photographic ID
                          </label>
                        </div>
                        {nonphotoIdText.value ? (
                          <span className="text-[13.5px] font-medium text-slate-700">
                            {nonphotoIdText.value}
                          </span>
                        ) : null}
                        <FileUploadDisplay
                          label="Uploaded Document"
                          fileData={fileNonPhotographicId}
                          onFileClick={handleFileClick}
                        />
                      </div>
                    )}

                    {/* Country where issued */}
                    <div className="flex min-w-0 flex-col">
                      <InfoField
                        label="Country where issued"
                        field={issuedCountry}
                        fieldLabel="Country where issued"
                        fieldValue={issuedCountry?.value?.name}
                        onStatusClick={handleStatusClick}
                        value={issuedCountry?.value?.name}
                        wide
                      />
                      {/* FIX (passport state_of_issue): a passport has no
                          state of issue — only render the Australian state
                          for non-passport documents that actually carry a
                          state value (also guards against a null crash). */}
                      {(applicantCountry.value.id == 14
                        ? photoId
                        : photoIdFirst) != 1 &&
                        issuedCountry?.value?.id == 14 &&
                        issuedState?.value && (
                          <InfoField
                            label="State or Territory in Australia"
                            field={issuedState}
                            fieldLabel="State or Territory in Australia"
                            fieldValue={issuedState.value.name}
                            onStatusClick={handleStatusClick}
                            value={issuedState.value.name}
                            wide
                          />
                        )}
                      {applicantCountry.value.id != 14 && (
                        <>
                          <label
                            htmlFor="investmentType"
                            className="flex items-center whitespace-normal words-break py-2.5 text-[11px] font-bold uppercase tracking-[.06em] text-slate-500"
                          >
                            Second Document Details
                          </label>
                          <InfoField
                            label="Country where issued"
                            field={issuedCountrySecond}
                            fieldLabel="Country where issued"
                            fieldValue={issuedCountrySecond?.value?.name}
                            onStatusClick={handleStatusClick}
                            value={issuedCountrySecond?.value?.name}
                            wide
                          />
                          {photoIdSecond != 1 &&
                            issuedCountrySecond?.value?.id == 14 &&
                            issuedStateSecond?.value && (
                              <InfoField
                                label="State or Territory in Australia"
                                field={issuedStateSecond}
                                fieldLabel="State or Territory in Australia"
                                fieldValue={issuedStateSecond.value.name}
                                onStatusClick={handleStatusClick}
                                value={issuedStateSecond.value.name}
                                wide
                              />
                            )}
                        </>
                      )}
                    </div>
                  </div>
                  <AdditionalDocumentsReadOnly
                    documents={additionalDocuments}
                    photographicDocuments={additionalPhotographicDocuments}
                    onFileClick={handleFileClick}
                    onStatusClick={handleStatusClick}
                  />
                </CollapsibleSection>
              </div>
              {/* End  */}

              {(pendingQuestions.length > 0 || completedGroups.length > 0) && (
                <div className="bg-white s rounded-2xl p-4">
                  <div className="mt-4 rounded-2xl border border-slate-200 bg-white p-4">
                    {pendingQuestions.length > 0 && (
                      <div className="w-full p-4">
                        <UserQuestionnaire
                          apidata={pendingQuestions}
                          customerName={firstNameSignup + ' ' + lastNameSignup}
                          isPending={true}
                          heading={'Customer Submitted ECDD Responses'}
                        />
                      </div>
                    )}
                    {completedGroups.length > 0 && (
                      <div className="w-full p-4">
                        <UserQuestionnaire
                          apidata={completedGroups}
                          customerName={firstNameSignup + ' ' + lastNameSignup}
                          isPending={false}
                          heading={'Customer Submitted ECDD Responses'}
                        />
                      </div>
                    )}
                  </div>
                </div>
              )}
              <div className="mt-6 flex items-center bg-[#005A9C] p-4">
                {/* Right Section: Download Button */}
                <div className="flex w-full items-center justify-end">
                  {customerStatus != 'active' && (
                    <div
                      ref={dropdownRef}
                      className="relative mr-4 inline-block"
                    >
                      {/* Button */}
                      <div
                        className="flex w-40 cursor-pointer items-center justify-between border border-white px-2 py-2 text-sm rounded-full"
                        onClick={() => setIsOpenAction(!isOpenAction)}
                      >
                        <span className="pl-4 text-right text-white">
                          Actions
                        </span>
                        <span className="text-gray-500">
                          {' '}
                          <img
                            src="/white-dropdown.svg"
                            alt="document-download"
                            className="pr-2"
                          />
                        </span>
                      </div>

                      {/* Dropdown Menu */}
                      {isOpenAction && (
                        <div className="absolute right-0 top-[-250%] z-10 w-40 rounded-md bg-white p-2 text-xs text-black shadow-lg">
                          <ul>
                            <li
                              onClick={(e) => {
                                setLoadingUpdate(true);
                                handleUpdateApplication(e, 'approve');
                              }}
                              className="cursor-pointer p-2 hover:bg-[#375AE7] hover:text-white"
                            >
                              Approve Application
                            </li>
                            <li
                              onClick={(e) => {
                                setLoadingUpdate(true);
                                handleUpdateApplication(e, 'reject');
                              }}
                              className="cursor-pointer p-2 text-[#FF5050] hover:bg-[#375AE7] hover:text-[#FF5050]"
                            >
                              Reject Application
                            </li>
                            <li
                              onClick={(e) => {
                                setLoadingUpdate(true);
                                handleUpdateApplication(e, 'resubmit');
                              }}
                              className="cursor-pointer p-2 text-[#FF5050] hover:bg-[#375AE7] hover:text-[#FF5050]"
                            >
                              Send for resubmit
                            </li>
                          </ul>
                        </div>
                      )}
                    </div>
                  )}
                  {customerStatus == 'active' && (
                    <div
                      ref={dropdownRef}
                      className="relative mr-4 inline-block"
                    >
                      {/* Button */}
                      <div
                        className="flex w-40 cursor-pointer border border-white py-2 text-sm rounded-full"
                        onClick={() => {
                          setLoadingUpdate(true);
                          handleSendReverification();
                        }}
                      >
                        <span className="pl-4 text-right text-white">
                          Send for resubmit
                        </span>
                      </div>
                    </div>
                  )}
                </div>
              </div>
              {showModal && (
                <EDDModal
                  pendingQuestions={pendingQuestions}
                  completedQuestions={completedQuestions}
                  closeModal={() => {
                    setShowModal(false);
                    getEddResponses();
                  }}
                />
              )}
            </>
          )}
        </>
      )}
      {isModalOpen && currentDocument && (
        <DocumentPreview
          fileUrl={currentDocument.presigned_url}
          fileName={currentDocument.file_name}
          onClose={() => setIsModalOpen(false)}
        />
      )}
    </div>
  );
};
const unwrapVerificationValue = (field) => {
  let value = field;
  let depth = 0;
  while (
    value &&
    typeof value === 'object' &&
    Object.prototype.hasOwnProperty.call(value, 'value') &&
    depth < 4
  ) {
    value = value.value;
    depth += 1;
  }
  return value;
};

const isNonEmptyDocumentValue = (value) => {
  const unwrapped = unwrapVerificationValue(value);
  return (
    unwrapped !== null &&
    unwrapped !== undefined &&
    unwrapped !== '' &&
    !(typeof unwrapped === 'string' && unwrapped.trim() === '')
  );
};

const documentFieldLabel = (key) =>
  key
    .replace(/_/g, ' ')
    .replace(/\b\w/g, (character) => character.toUpperCase());

const getDocumentFile = (field) => {
  let file = unwrapVerificationValue(field);
  if (Array.isArray(file)) file = file[0];
  if (file && file.file && typeof file.file === 'object') file = file.file;
  if (typeof file === 'string' && file.trim()) {
    return { presigned_url: file, file_name: 'View document' };
  }
  return file && (file.presigned_url || file.url || file.file_url)
    ? file
    : null;
};

const AdditionalDocumentsReadOnly = ({
  documents = [],
  photographicDocuments = [],
  onFileClick,
  onStatusClick,
}) => {
  const allDocuments = [
    ...photographicDocuments.map((document) => ({
      document,
      photographic: true,
    })),
    ...documents.map((document) => ({ document, photographic: false })),
  ];
  if (!allDocuments.length) return null;

  // These are transport/verification identifiers rather than user-entered
  // document fields. Keep the table driven by the API's remaining keys.
  const ignoredKeys = new Set([
    'id',
    'uuid',
    'unique_id',
    'verification_id',
    'document_id',
    'document_type_code',
    'file',
    'back_file',
  ]);

  const rows = allDocuments.flatMap(
    ({ document, photographic }, documentIndex) => {
      const type =
        unwrapVerificationValue(document.document_type_name) ||
        unwrapVerificationValue(document.document_type) ||
        (photographic ? 'Photographic document' : 'Additional document');
      const fieldRows = Object.entries(document).filter(
        ([key, value]) =>
          !ignoredKeys.has(key) &&
          !key.endsWith('_id') &&
          key !== 'document_type_name' &&
          key !== 'document_type' &&
          isNonEmptyDocumentValue(value),
      );
      const fileRows = [
        ['Main document', document.file],
        ['Back of document', document.back_file],
      ].filter(([, value]) => getDocumentFile(value));
      const valueRows = fieldRows.map(([key, field]) => ({
        key: `${documentIndex}-${key}`,
        type,
        field: documentFieldLabel(key),
        value: unwrapVerificationValue(field),
        verification:
          field && typeof field === 'object' && field.value !== undefined
            ? field
            : null,
      }));
      const documentFileRows = fileRows.map(([field, fileField]) => ({
        key: `${documentIndex}-${field}`,
        type,
        field,
        file: getDocumentFile(fileField),
        verification:
          fileField &&
          typeof fileField === 'object' &&
          fileField.value !== undefined
            ? fileField
            : null,
      }));
      return [...valueRows, ...documentFileRows];
    },
  );

  const displayValue = (value) => {
    const unwrapped = unwrapVerificationValue(value);
    if (typeof unwrapped === 'object') {
      return unwrapped?.name || unwrapped?.label || JSON.stringify(unwrapped);
    }
    return String(unwrapped);
  };

  return (
    <div className="w-full p-4">
      <CollapsibleSection
        title="Additional Documents"
        subtitle="Supporting and alternate photographic documents"
        accent="#F59E0B"
        defaultOpen={true}
      >
        <div className="overflow-hidden rounded-2xl border border-slate-200/90 bg-white shadow-[0_1px_2px_rgba(15,23,42,.04),0_20px_48px_-32px_rgba(15,23,42,.35)]">
          <div className="overflow-x-auto">
            <table className="w-full border-separate border-spacing-0 text-xs">
              <thead className="bg-slate-50/70 text-left text-[10px] uppercase tracking-wide text-slate-400">
                <tr>
                  <th className="px-4 py-3 font-semibold">Document type</th>
                  <th className="px-4 py-3 font-semibold">Field</th>
                  <th className="px-4 py-3 font-semibold">Value</th>
                  <th className="px-4 py-3 font-semibold">File</th>
                  <th className="px-4 py-3 font-semibold">Review</th>
                </tr>
              </thead>
              <tbody className="text-sm font-medium text-slate-800">
                {rows.map((row) => (
                  <tr
                    key={row.key}
                    className="border-t border-slate-100 align-top hover:bg-slate-50/60"
                  >
                    <td className="px-4 py-3 whitespace-nowrap">{row.type}</td>
                    <td className="px-4 py-3 whitespace-nowrap text-slate-600">
                      {row.field}
                    </td>
                    <td className="px-4 py-3 min-w-[14rem] break-words">
                      {row.file ? 'Uploaded file' : displayValue(row.value)}
                    </td>
                    <td className="px-4 py-3 min-w-[13rem]">
                      {row.file ? (
                        <button
                          type="button"
                          onClick={() => onFileClick(row.file)}
                          className="cursor-pointer text-left text-slate-800 underline"
                        >
                          {row.file.file_name ||
                            row.file.name ||
                            'View document'}
                        </button>
                      ) : null}
                    </td>
                    <td className="px-4 py-3">
                      {row.verification ? (
                        <StatusButton
                          status={row.verification.status}
                          count={row.verification.comments?.length}
                          openSection={() =>
                            onStatusClick(
                              row.verification,
                              `${row.type} - ${row.field}`,
                              row.file || displayValue(row.value),
                              row.file ? 'file' : '',
                            )
                          }
                        />
                      ) : null}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </CollapsibleSection>
    </div>
  );
};

const CheckItem = ({ label, status }) => {
  const styles = {
    completed: 'bg-emerald-50 text-emerald-700 border-emerald-100',
    found: 'bg-red-50 text-red-700 border-red-100',
    warn: 'bg-amber-50 text-amber-700 border-amber-100',
  };

  const icons = {
    completed: '✔',
    found: '✖',
    warn: '⚠',
  };

  return (
    <div
      className={`flex justify-between items-center p-3 rounded-xl border shadow-sm ${styles[status]} transition hover:shadow-md`}
    >
      <span className="text-xs font-medium text-gray-800">{label}</span>

      <span className="text-xs font-semibold flex items-center gap-1">
        {icons[status]} {status.toUpperCase()}
      </span>
    </div>
  );
};

/* ================================================================== */
/*  SECTION_STATUS_STYLES — pill style per section.status value        */
/* ================================================================== */
/* Accepts both legacy lowercase values and the API uppercase enums
   (IN_REVIEW, APPROVED, REJECTED, PENDING) from onboarding_sections */
const SECTION_STATUS_STYLES = {
  approved: 'border-emerald-200 bg-emerald-50 text-emerald-700',
  completed: 'border-emerald-200 bg-emerald-50 text-emerald-700',
  pending: 'border-amber-200 bg-amber-50 text-amber-700',
  rejected: 'border-red-200 bg-red-50 text-red-700',
  in_review: 'border-sky-200 bg-sky-50 text-sky-700',
};

/* ================================================================== */
/*  CollapsibleSection — modern expandable section card                */
/*  - click the header to expand / collapse                            */
/*  - shows the section.status pill (when `section` is provided)       */
/*  - shows the "Approve this section" button (when section has id)    */
/*  - children render inside an animated collapsing body               */
/* ================================================================== */
const CollapsibleSection = ({
  icon,
  accent = '#375AE7',
  title,
  subtitle,
  pill,
  section,
  onApprove,
  approving = false,
  defaultOpen = false,
  children,
}) => {
  const [open, setOpen] = useState(defaultOpen);

  const statusKey = section?.status ? String(section.status).toLowerCase() : '';
  const statusPill =
    statusKey && SECTION_STATUS_STYLES[statusKey] ? (
      <span
        className={`hidden items-center gap-1.5 rounded-full border px-2.5 py-[5px] text-[10.5px] font-semibold uppercase tracking-[.06em] sm:inline-flex ${SECTION_STATUS_STYLES[statusKey]}`}
      >
        <span className="h-1.5 w-1.5 rounded-full bg-current" />
        {statusKey
          .split('_')
          .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
          .join(' ')}
      </span>
    ) : null;

  return (
    <section className="mt-2 overflow-hidden rounded-2xl border border-slate-200/90 bg-white shadow-[0_1px_2px_rgba(15,23,42,.04),0_20px_48px_-32px_rgba(15,23,42,.35)]">
      {/* Header (click to toggle) */}
      <div
        role="button"
        tabIndex={0}
        onClick={() => setOpen((o) => !o)}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') setOpen((o) => !o);
        }}
        className="flex w-full cursor-pointer select-none flex-wrap items-center justify-between gap-x-4 gap-y-2 px-4 py-3.5 transition-colors hover:bg-slate-50/70 sm:px-5"
      >
        <div className="flex min-w-0 items-center gap-3">
          <span
            className="flex h-9 w-9 shrink-0 items-center justify-center rounded-[10px]"
            style={{
              background: `${accent}14`,
              color: accent,
            }}
          >
            {icon}
          </span>
          <div className="min-w-0 leading-tight">
            <h2 className="truncate text-[14.5px] font-bold tracking-tight text-slate-800">
              {title}
            </h2>
            {subtitle ? (
              <p className="text-[11px] font-medium text-slate-400">
                {subtitle}
              </p>
            ) : null}
          </div>
          {statusPill}
          {pill}
        </div>

        <div className="flex shrink-0 items-center gap-2">
          {section?.id ? (
            <span
              role="button"
              onClick={(e) => {
                e.stopPropagation();
                if (!approving) onApprove();
              }}
              className={`inline-flex h-9 items-center gap-2 rounded-lg bg-[#375AE7] px-4 text-xs font-bold tracking-wide text-white shadow-md shadow-[#375AE7]/30 transition-all duration-200 active:scale-[0.97] ${
                approving
                  ? 'cursor-wait opacity-70'
                  : 'hover:-translate-y-0.5 hover:bg-[#2F4FD0] hover:shadow-lg hover:shadow-[#375AE7]/40'
              }`}
            >
              {approving ? (
                <span className="h-3 w-3 animate-spin rounded-full border-2 border-white border-t-transparent" />
              ) : (
                <svg
                  width="12"
                  height="12"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="3"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  aria-hidden="true"
                >
                  <path d="M20 6 9 17l-5-5" />
                </svg>
              )}
              {approving ? 'Approving…' : 'Approve this section'}
            </span>
          ) : null}
          <span
            className={`flex h-7 w-7 items-center justify-center rounded-full border border-slate-200 bg-white text-slate-400 shadow-sm transition-transform duration-300 ${
              open ? 'rotate-180' : ''
            }`}
          >
            <svg
              width="13"
              height="13"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.4"
              strokeLinecap="round"
              strokeLinejoin="round"
              aria-hidden="true"
            >
              <path d="m6 9 6 6 6-6" />
            </svg>
          </span>
        </div>
      </div>

      {/* Collapsing body */}
      <div
        className={`grid transition-[grid-template-rows] duration-300 ease-out ${
          open ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]'
        }`}
      >
        <div className="overflow-hidden">
          <div className="border-t border-slate-100">{children}</div>
        </div>
      </div>
    </section>
  );
};

/* ================================================================== */
/*  InfoField — consistent label + value row                           */
/*  Keeps even vertical spacing between fields and renders a muted     */
/*  dash (instead of an empty gap) when the value doesn't exist.       */
/*  When `field` is provided it keeps the original StatusButton        */
/*  (status, comment count, review popup) behaviour intact.            */
/* ================================================================== */
const InfoField = ({
  label,
  field,
  fieldLabel,
  fieldValue,
  fieldType = '',
  onStatusClick,
  value,
  wide = false,
}) => {
  const isEmpty =
    value === null ||
    value === undefined ||
    value === '' ||
    (typeof value === 'string' && value.trim() === '');

  return (
    <div className="mb-1 flex break-inside-avoid flex-col gap-1.5 py-2.5">
      <div className="flex items-start justify-between gap-3">
        <label
          htmlFor="investmentType"
          className={`flex items-start whitespace-normal words-break text-[10.5px] font-semibold uppercase tracking-[.06em] text-slate-500 ${
            wide ? 'w-40 md:w-full' : ''
          }`}
        >
          {label}
        </label>
        {field ? (
          <StatusButton
            status={field.status}
            count={field.comments?.length}
            openSection={() =>
              onStatusClick(field, fieldLabel, fieldValue, fieldType)
            }
          />
        ) : null}
      </div>
      {/* Value row renders only when a value exists — empty fields take
          no space and show no placeholder */}
      {!isEmpty ? (
        <div className="break-words text-[13.5px] font-medium leading-snug text-slate-700">
          {value}
        </div>
      ) : null}
    </div>
  );
};

export default ReviewKYC;
